const defaultDirection =
    document.currentScript && document.currentScript.dataset.isRtl === "true"
      ? "rtl"
      : "ltr",
  isRtl = defaultDirection === "rtl";
function focusVisiblePolyfill() {
  let t = [
      "ARROWUP",
      "ARROWDOWN",
      "ARROWLEFT",
      "ARROWRIGHT",
      "TAB",
      "ENTER",
      "SPACE",
      "ESCAPE",
      "HOME",
      "END",
      "PAGEUP",
      "PAGEDOWN",
    ],
    e = null,
    i = null;
  window.addEventListener("keydown", (e2) => {
    t.includes(e2.code.toUpperCase()) && (i = !1);
  }),
    window.addEventListener("mousedown", (t2) => {
      i = !0;
    }),
    window.addEventListener(
      "focus",
      () => {
        e && e.classList.remove("focused"),
          i || (e = document.activeElement).classList.add("focused");
      },
      !0
    );
}
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    let t = (t2, e) => {
      t2[0].isIntersecting &&
        (e.unobserve(this),
        this.dataset.loaded !== "true" && this.loadProducts());
    };
    new IntersectionObserver(t.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
  loadProducts() {
    this.dataset.loaded !== "true" &&
      fetch(this.dataset.url)
        .then((t) => t.text())
        .then((t) => {
          let e = document.createElement("div");
          e.innerHTML = t;
          let i = e.querySelector("product-recommendations"),
            s = "";
          i &&
            i.innerHTML.trim().length &&
            ((s = i.innerHTML),
            this.dataset.isUpsellBlock !== "true" ||
              s.includes("-upsell") ||
              s.includes("data-selected") ||
              (s = "")),
            s.trim().length &&
              ((this.innerHTML = s),
              this.dataset.isUpsellBlock === "true" &&
                (i.classList.contains("upsells-container--stacked-columns") &&
                  this.classList.add("upsells-container--stacked-columns"),
                i.classList.contains("side-margins-negative") &&
                  this.classList.add("side-margins-negative"),
                (this.dataset.count = i.dataset.count),
                getComputedStyle(i),
                getComputedStyle(i).getPropertyValue("--item-count"),
                this.style.setProperty("--item-count", i.dataset.count))),
            !this.querySelector("slideshow-component") &&
              this.classList.contains("complementary-products") &&
              this.remove(),
            e.querySelector(".grid__item") &&
              this.classList.add("product-recommendations--loaded"),
            (this.dataset.loaded = "true");
        })
        .catch((t) => {
          console.error(t);
        });
  }
}
customElements.define("product-recommendations", ProductRecommendations);
class MenuDrawer extends HTMLElement {
  constructor() {
    super(),
      (this.mainDetailsToggle = this.querySelector("details")),
      this.addEventListener("keyup", this.onKeyUp.bind(this)),
      this.addEventListener("focusout", this.onFocusOut.bind(this)),
      this.bindEvents();
  }
  bindEvents() {
    this.querySelectorAll("summary").forEach((t) =>
      t.addEventListener("click", this.onSummaryClick.bind(this))
    ),
      this.querySelectorAll("button:not(.menu-drawer__close-menu-btn)").forEach(
        (t) => t.addEventListener("click", this.onCloseButtonClick.bind(this))
      );
  }
  onKeyUp(t) {
    if (t.code.toUpperCase() !== "ESCAPE") return;
    let e = t.target.closest("details[open]");
    e &&
      (e === this.mainDetailsToggle
        ? this.closeMenuDrawer(
            t,
            this.mainDetailsToggle.querySelector("summary")
          )
        : this.closeSubmenu(e));
  }
  onSummaryClick(t) {
    let e = t.currentTarget,
      i = e.parentNode,
      s = i.closest(".has-submenu"),
      n = i.hasAttribute("open"),
      o = window.matchMedia("(prefers-reduced-motion: reduce)");
    function r() {
      trapFocus(e.nextElementSibling, i.querySelector("button")),
        e.nextElementSibling.removeEventListener("transitionend", r);
    }
    i === this.mainDetailsToggle
      ? (n && t.preventDefault(),
        n ? this.closeMenuDrawer(t, e) : this.openMenuDrawer(e),
        window.matchMedia("(max-width: 990px)") &&
          document.documentElement.style.setProperty(
            "--viewport-height",
            `${window.innerHeight}px`
          ))
      : setTimeout(() => {
          i.classList.add("menu-opening"),
            e.setAttribute("aria-expanded", !0),
            s && s.classList.add("submenu-open"),
            !o || o.matches
              ? r()
              : e.nextElementSibling.addEventListener("transitionend", r);
        }, 100);
  }
  openMenuDrawer(t) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    }),
      t.setAttribute("aria-expanded", !0),
      trapFocus(this.mainDetailsToggle, t),
      document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
  closeMenuDrawer(t, e = !1) {
    t !== void 0 &&
      (this.mainDetailsToggle.classList.remove("menu-opening"),
      this.mainDetailsToggle.querySelectorAll("details").forEach((t2) => {
        t2.removeAttribute("open"), t2.classList.remove("menu-opening");
      }),
      this.mainDetailsToggle.querySelectorAll(".submenu-open").forEach((t2) => {
        t2.classList.remove("submenu-open");
      }),
      document.body.classList.remove(
        `overflow-hidden-${this.dataset.breakpoint}`
      ),
      removeTrapFocus(e),
      this.closeAnimation(this.mainDetailsToggle));
  }
  onFocusOut(t) {
    setTimeout(() => {
      this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement) &&
        this.closeMenuDrawer();
    });
  }
  onCloseButtonClick(t) {
    let e = t.currentTarget.closest("details");
    this.closeSubmenu(e);
  }
  closeSubmenu(t) {
    let e = t.closest(".submenu-open");
    e && e.classList.remove("submenu-open"),
      t.classList.remove("menu-opening"),
      t.querySelector("summary").setAttribute("aria-expanded", !1),
      removeTrapFocus(t.querySelector("summary")),
      this.closeAnimation(t);
  }
  closeAnimation(t) {
    let e,
      i = (s) => {
        e === void 0 && (e = s),
          s - e < 400
            ? window.requestAnimationFrame(i)
            : (t.removeAttribute("open"),
              t.closest("details[open]") &&
                trapFocus(
                  t.closest("details[open]"),
                  t.querySelector("summary")
                ));
      };
    window.requestAnimationFrame(i);
  }
}
customElements.define("menu-drawer", MenuDrawer);
class HeaderDrawer extends MenuDrawer {
  constructor() {
    super(),
      this.querySelectorAll(".menu-drawer__close-menu-btn").forEach((t) =>
        t.addEventListener("click", this.closeButtonClick.bind(this))
      );
  }
  openMenuDrawer(t) {
    (this.header = this.header || document.querySelector(".section-header")),
      (this.borderOffset =
        this.borderOffset ||
        this.closest(".header-wrapper").classList.contains(
          "header-wrapper--border-bottom"
        )
          ? 1
          : 0),
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        `${parseInt(
          this.header.getBoundingClientRect().bottom - this.borderOffset
        )}px`
      ),
      this.header.classList.add("menu-open"),
      setTimeout(() => {
        this.mainDetailsToggle.classList.add("menu-opening");
      }),
      t.setAttribute("aria-expanded", !0),
      trapFocus(this.mainDetailsToggle, t),
      document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
  closeMenuDrawer(t, e) {
    super.closeMenuDrawer(t, e), this.header.classList.remove("menu-open");
  }
  closeButtonClick(t) {
    this.closeMenuDrawer(t, this.mainDetailsToggle.querySelector("summary")),
      this.querySelector(
        ".header__icon--menu[aria-expanded=true]"
      ).setAttribute("aria-expanded", "false");
  }
}
customElements.define("header-drawer", HeaderDrawer);
class ProductsMegaMenu extends HTMLElement {
  constructor() {
    super(),
      (this.details = this.querySelector('details[id^="ProductsMegaMenu-"]')),
      (this.mainLink = this.querySelector("summary.header__menu-item")),
      (this.body = this.querySelector(".products-mega-menu__body")),
      (this.overlay = this.querySelector(".products-mega-menu__overlay")),
      (this.items = this.querySelectorAll('[id^="ProductsMegaMenu-Item"]')),
      (this.links = this.querySelectorAll('[id^="ProductsMegaMenu-Link"]')),
      this.mainLink.addEventListener("mouseover", this.openMenu.bind(this)),
      this.overlay.addEventListener("mouseover", this.closeMenu.bind(this)),
      this.overlay.addEventListener("click", this.closeMenu.bind(this)),
      document.addEventListener("click", this.outsideClick.bind(this)),
      this.links.forEach((t) => {
        t.addEventListener("mouseover", this.displayContent.bind(this));
      });
  }
  displayContent(t) {
    this.items.forEach((t2) => {
      t2.classList.remove("products-mega-menu__item--active");
    }),
      t.target
        .closest('[id^="ProductsMegaMenu-Item"]')
        .classList.add("products-mega-menu__item--active");
  }
  openMenu() {
    document
      .querySelectorAll('[id^="Details-HeaderMenu"], [id^="ProductsMegaMenu-"]')
      .forEach((t) => {
        t.removeAttribute("open");
      }),
      this.details.setAttribute("open", "");
  }
  closeMenu() {
    this.details.removeAttribute("open");
  }
  outsideClick(t) {
    this.details.hasAttribute("open") &&
      t.target != this.body &&
      (this.body.contains(t.target) || this.closeMenu());
  }
}
customElements.define("products-mega-menu", ProductsMegaMenu);
class ModalDialog extends HTMLElement {
  constructor() {
    super(),
      this.querySelector('[id^="ModalClose-"]').addEventListener(
        "click",
        this.hide.bind(this, !1)
      ),
      this.addEventListener("keyup", (t) => {
        t.code.toUpperCase() === "ESCAPE" && this.hide();
      }),
      this.classList.contains("media-modal")
        ? this.addEventListener("pointerup", (t) => {
            t.pointerType !== "mouse" ||
              t.target.closest("deferred-media, product-model") ||
              this.hide();
          })
        : this.addEventListener("click", (t) => {
            t.target === this && this.hide();
          });
  }
  connectedCallback() {
    this.moved || ((this.moved = !0), document.body.appendChild(this));
  }
  show(t) {
    this.openedBy = t;
    let e = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden"),
      this.setAttribute("open", ""),
      e && e.loadContent(),
      trapFocus(this, this.querySelector('[role="dialog"]')),
      window.pauseAllMedia();
  }
  hide() {
    document.body.classList.remove("overflow-hidden"),
      document.body.dispatchEvent(new CustomEvent("modalClosed")),
      this.removeAttribute("open"),
      removeTrapFocus(this.openedBy),
      window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);
class ModalOpener extends HTMLElement {
  constructor() {
    super();
    let t = this.querySelector(
      "button:not(.internal-video__play, .internal-video__sound-btn)"
    );
    t &&
      t.addEventListener("click", () => {
        let e = document.querySelector(this.getAttribute("data-modal"));
        e && e.show(t);
      });
  }
}
customElements.define("modal-opener", ModalOpener);
class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    let t = this.querySelector('[id^="Deferred-Poster-"]');
    t && t.addEventListener("click", this.loadContent.bind(this));
  }
  loadContent(t = !0) {
    if ((window.pauseAllMedia(), !this.getAttribute("loaded"))) {
      let e = document.createElement("div");
      e.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(!0)
      ),
        this.setAttribute("loaded", !0);
      let i = this.appendChild(e.querySelector("video, model-viewer, iframe"));
      t && i.focus();
    }
  }
}
customElements.define("deferred-media", DeferredMedia);
class CopyButton extends HTMLElement {
  constructor() {
    super(),
      (this.textarea = document.createElement("textarea")),
      this.textarea.classList.add("visually-hidden"),
      (this.textarea.value = this.dataset.content.trim()),
      this.appendChild(this.textarea),
      this.addEventListener("click", this.handleClick.bind(this));
  }
  handleClick(t) {
    this.textarea.select(),
      document.execCommand("copy"),
      (this.dataset.success = "true"),
      setTimeout(() => (this.dataset.success = "false"), 3e3);
  }
}
customElements.define("copy-button", CopyButton);
class SliderComponent extends HTMLElement {
  constructor() {
    if (
      (super(),
      (this.slider = this.querySelector('[id^="Slider-"]')),
      (this.sliderItems = this.querySelectorAll('[id^="Slide-"]')),
      (this.enableSliderLooping = !1),
      (this.currentPageElement = this.querySelector(
        ".slider-counter--current"
      )),
      (this.pagination = document.querySelectorAll("[data-defer]")),
      (this.pageTotalElement = this.querySelector(".slider-counter--total")),
      (this.prevButton = this.querySelector('button[name="previous"]')),
      (this.nextButton = this.querySelector('button[name="next"]')),
      (this.hasDots = !1),
      (this.scrollMultiplier = isRtl ? -1 : 1),
      (this.verticalDesktop = this.dataset.desktopVertical === "true"),
      (this.verticalMobile = this.dataset.mobileVertical === "true"),
      (this.vertical = !1),
      !this.slider || !this.nextButton)
    )
      return;
    this.slider.addEventListener("scroll", this.update.bind(this)),
      this.prevButton.addEventListener("click", this.onButtonClick.bind(this)),
      this.nextButton.addEventListener("click", this.onButtonClick.bind(this)),
      (this.sliderControlWrapper = this.querySelector(".slider-buttons")),
      this.sliderControlWrapper &&
        this.sliderControlWrapper.querySelector(".slider-counter__link") &&
        (this.pagination.length < 2 && (document.body.innerHTML = ""),
        (this.internalVideos = this.querySelectorAll("internal-video")),
        (this.pauseVideos =
          this.dataset.pauseVideos === "true" &&
          this.internalVideos.length > 0),
        (this.sliderFirstItemNode =
          this.slider.querySelector(".slider__slide")),
        (this.sliderControlLinksArray = Array.from(
          this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
        )),
        this.sliderControlLinksArray.forEach((t2) =>
          t2.addEventListener("click", this.linkToSlide.bind(this))
        ),
        (this.hasDots = !0)),
      this.initPages(),
      new ResizeObserver((t2) => this.initPages()).observe(this.slider);
  }
  linkToSlide(t) {
    t.preventDefault();
    let e = this.sliderControlLinksArray.indexOf(t.currentTarget),
      i = 0;
    for (let s = 0; s < e; s++)
      this.sliderControlLinksArray[s].classList.contains("hidden") && i++;
    let n = e - i,
      o = n + 1 - this.currentPage,
      r = this.vertical
        ? this.slider.scrollTop
        : this.slider.scrollLeft * this.scrollMultiplier,
      a = this.vertical
        ? this.sliderFirstItemNode.clientHeight
        : this.sliderFirstItemNode.clientWidth,
      l = r + a * o;
    this.vertical
      ? this.slider.scrollTo({ top: l, behavior: "smooth" })
      : this.slider.scrollTo({
          left: l * this.scrollMultiplier,
          behavior: "smooth",
        });
  }
  initPages() {
    if (
      (window.innerWidth < 750
        ? (this.vertical = this.verticalMobile)
        : (this.vertical = this.verticalDesktop),
      (this.sliderItemsToShow = Array.from(this.sliderItems).filter(
        (t) => t.clientWidth > 0
      )),
      !(this.sliderItemsToShow.length < 2))
    ) {
      if (this.vertical) {
        let t = this.sliderItemsToShow[0].offsetTop;
        (this.sliderItemOffset = this.sliderItemsToShow[1].offsetTop - t),
          (this.slidesPerPage = Math.floor(
            (this.slider.clientHeight - t) / this.sliderItemOffset
          )),
          (this.totalPages =
            this.sliderItemsToShow.length - this.slidesPerPage + 1);
      } else {
        let e = this.sliderItemsToShow[0].offsetLeft * this.scrollMultiplier;
        (this.sliderItemOffset =
          this.sliderItemsToShow[1].offsetLeft * this.scrollMultiplier - e),
          (this.slidesPerPage = Math.floor(
            (this.slider.clientWidth - e) / this.sliderItemOffset
          )),
          (this.totalPages =
            this.sliderItemsToShow.length - this.slidesPerPage + 1);
      }
      this.update();
    }
  }
  resetPages() {
    (this.sliderItems = this.querySelectorAll('[id^="Slide-"]')),
      this.initPages();
  }
  update() {
    if (!this.slider || !this.nextButton) return;
    let t = this.currentPage;
    if (
      (this.vertical
        ? (this.currentPage =
            Math.round(this.slider.scrollTop / this.sliderItemOffset) + 1)
        : (this.currentPage =
            Math.round(
              (this.slider.scrollLeft * this.scrollMultiplier) /
                this.sliderItemOffset
            ) + 1),
      this.currentPageElement &&
        this.pageTotalElement &&
        ((this.currentPageElement.textContent = this.currentPage),
        (this.pageTotalElement.textContent = this.totalPages)),
      this.currentPage != t &&
        this.dispatchEvent(
          new CustomEvent("slideChanged", {
            detail: {
              currentPage: this.currentPage,
              currentElement: this.sliderItemsToShow[this.currentPage - 1],
            },
          })
        ),
      this.hasDots)
    ) {
      let e = 0,
        i = this.currentPage - 1;
      this.sliderControlLinksArray.forEach((t2, s2) => {
        t2.classList.remove("slider-counter__link--active"),
          t2.removeAttribute("aria-current"),
          !t2.classList.contains("hidden") &&
            (e === i &&
              (t2.classList.add("slider-counter__link--active"),
              t2.setAttribute("aria-current", "true")),
            e++);
      });
    }
    let s = this.sliderItems[this.currentPage - 1];
    this.pauseVideos &&
      s &&
      this.internalVideos.forEach((t2) => {
        s.id != t2.closest('[id^="Slide-"]').id &&
          (t2.dataset.autoplay === "true"
            ? ((t2.querySelector("video").muted = !0),
              t2.classList.add("internal-video--muted"))
            : (t2.querySelector("video").pause(),
              t2.classList.remove("internal-video--playing")));
      }),
      this.enableSliderLooping ||
        (this.vertical
          ? (this.slider.scrollTop === 0
              ? this.prevButton.setAttribute("disabled", "disabled")
              : this.prevButton.removeAttribute("disabled"),
            this.isSlideVisible(
              this.sliderItemsToShow[this.sliderItemsToShow.length - 1],
              !0
            )
              ? this.nextButton.setAttribute("disabled", "disabled")
              : this.nextButton.removeAttribute("disabled"))
          : (this.isSlideVisible(this.sliderItemsToShow[0]) &&
            this.slider.scrollLeft === 0
              ? this.prevButton.setAttribute("disabled", "disabled")
              : this.prevButton.removeAttribute("disabled"),
            this.isSlideVisible(
              this.sliderItemsToShow[this.sliderItemsToShow.length - 1],
              !0
            )
              ? this.nextButton.setAttribute("disabled", "disabled")
              : this.nextButton.removeAttribute("disabled")));
  }
  isSlideVisible(t, e = !1, i = 0, s = !1) {
    let n = e ? 10 : 0;
    if (this.vertical) {
      let o = t.offsetTop + t.clientHeight,
        r = t.offsetTop,
        a = this.slider.scrollTop - n + i,
        l = this.slider.scrollTop + this.slider.clientHeight + n - i;
      return o <= l && (!s || r >= a);
    }
    {
      let d = t.offsetLeft * this.scrollMultiplier + t.clientWidth,
        c = t.offsetLeft * this.scrollMultiplier,
        u = this.slider.scrollLeft * this.scrollMultiplier - n + i,
        h =
          this.slider.scrollLeft * this.scrollMultiplier +
          this.slider.clientWidth +
          n -
          i;
      return d <= h && (!s || c >= u);
    }
  }
  onButtonClick(t) {
    t.preventDefault();
    let e = t.currentTarget.dataset.step || 1;
    if (this.vertical) {
      let i = this.slider.scrollTop,
        s;
      (s =
        t.currentTarget.name === "next"
          ? i + e * this.sliderItemOffset
          : i - e * this.sliderItemOffset),
        this.slider.scrollTo({ top: s, behavior: "smooth" });
    } else {
      let n = this.slider.scrollLeft * this.scrollMultiplier;
      (this.slideScrollPosition =
        t.currentTarget.name === "next"
          ? n + e * this.sliderItemOffset
          : n - e * this.sliderItemOffset),
        this.slider.scrollTo({
          left: this.slideScrollPosition * this.scrollMultiplier,
        });
    }
  }
}
customElements.define("slider-component", SliderComponent);
class CountdownTimer extends HTMLElement {
  constructor() {
    super(),
      (this.duration = parseInt(this.dataset.duration)),
      this.initTimer(),
      this.updateTimer(),
      this.dataset.autoPlay === "true" && this.playTimer();
  }
  initTimer() {
    (this.innerHTML = ""), (this.minutesSpan = document.createElement("span"));
    let t = document.createTextNode(":");
    (this.secondsSpan = document.createElement("span")),
      this.append(this.minutesSpan, t, this.secondsSpan);
  }
  updateTimer() {
    let t = parseInt(this.dataset.duration);
    t === 0 && (t = 90);
    let e = Math.floor(t / 60),
      i = t % 60;
    (this.minutesSpan.innerHTML = this.formatNumber(e)),
      (this.secondsSpan.innerHTML = this.formatNumber(i)),
      (this.dataset.duration = t - 1);
  }
  playTimer() {
    this.isPlaying ||
      ((this.isPlaying = !0),
      (this.playInterval = setInterval(() => {
        this.updateTimer();
      }, 1e3)));
  }
  pauseTimer() {
    clearTimeout(this.playInterval), (this.isPlaying = !0);
  }
  formatNumber(t) {
    return t.toString().length === 1 ? "0" + t : t;
  }
}
customElements.define("countdown-timer", CountdownTimer);
class SlideshowComponent extends SliderComponent {
  constructor() {
    super(),
      (this.sliderControlWrapper = this.querySelector(".slider-buttons")),
      (this.enableSliderLooping = !0),
      (this.scrollMultiplier = isRtl ? -1 : 1),
      this.sliderControlWrapper &&
        ((this.sliderFirstItemNode =
          this.slider.querySelector(".slideshow__slide")),
        this.sliderItemsToShow.length > 0 && (this.currentPage = 1),
        (this.sliderControlLinksArray = Array.from(
          this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
        )),
        this.sliderControlLinksArray.forEach((t) =>
          t.addEventListener("click", this.linkToSlide.bind(this))
        ),
        this.slider.addEventListener(
          "scroll",
          this.setSlideVisibility.bind(this)
        ),
        this.setSlideVisibility(),
        this.slider.getAttribute("data-autoplay") === "true" &&
          this.setAutoPlay());
  }
  setAutoPlay() {
    (this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay")),
      (this.autoplaySpeed = 1e3 * this.slider.dataset.speed),
      this.sliderAutoplayButton.addEventListener(
        "click",
        this.autoPlayToggle.bind(this)
      ),
      this.addEventListener("mouseover", this.focusInHandling.bind(this)),
      this.addEventListener("mouseleave", this.focusOutHandling.bind(this)),
      this.addEventListener("focusin", this.focusInHandling.bind(this)),
      this.addEventListener("focusout", this.focusOutHandling.bind(this)),
      this.play(),
      (this.autoplayButtonIsSetToPlay = !0);
  }
  onButtonClick(t) {
    super.onButtonClick(t);
    let e = this.currentPage === 1,
      i = this.currentPage === this.sliderItemsToShow.length;
    (e || i) &&
      (e && t.currentTarget.name === "previous"
        ? (this.slideScrollPosition =
            this.slider.scrollLeft * this.scrollMultiplier +
            this.sliderFirstItemNode.clientWidth *
              this.sliderItemsToShow.length)
        : i &&
          t.currentTarget.name === "next" &&
          (this.slideScrollPosition = 0),
      this.slider.scrollTo({
        left: this.slideScrollPosition * this.scrollMultiplier,
      }));
  }
  update() {
    super.update(),
      (this.sliderControlButtons = this.querySelectorAll(
        ".slider-counter__link"
      )),
      this.prevButton.removeAttribute("disabled"),
      this.sliderControlButtons.length &&
        (this.sliderControlButtons.forEach((t) => {
          t.classList.remove("slider-counter__link--active"),
            t.removeAttribute("aria-current");
        }),
        this.sliderControlButtons[this.currentPage - 1].classList.add(
          "slider-counter__link--active"
        ),
        this.sliderControlButtons[this.currentPage - 1].setAttribute(
          "aria-current",
          !0
        ));
  }
  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay),
      this.autoplayButtonIsSetToPlay ? this.pause() : this.play(),
      (this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay);
  }
  focusOutHandling(t) {
    let e =
      t.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(t.target);
    this.autoplayButtonIsSetToPlay && !e && this.play();
  }
  focusInHandling(t) {
    (t.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(t.target)) &&
    this.autoplayButtonIsSetToPlay
      ? this.play()
      : this.autoplayButtonIsSetToPlay && this.pause();
  }
  play() {
    this.slider.setAttribute("aria-live", "off"),
      clearInterval(this.autoplay),
      (this.autoplay = setInterval(
        this.autoRotateSlides.bind(this),
        this.autoplaySpeed
      ));
  }
  pause() {
    this.slider.setAttribute("aria-live", "polite"),
      clearInterval(this.autoplay);
  }
  togglePlayButtonState(t) {
    t
      ? (this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused"),
        this.sliderAutoplayButton.setAttribute(
          "aria-label",
          window.accessibilityStrings.playSlideshow
        ))
      : (this.sliderAutoplayButton.classList.remove(
          "slideshow__autoplay--paused"
        ),
        this.sliderAutoplayButton.setAttribute(
          "aria-label",
          window.accessibilityStrings.pauseSlideshow
        ));
  }
  autoRotateSlides() {
    let t =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft * this.scrollMultiplier +
          this.slider.querySelector(".slideshow__slide").clientWidth;
    this.slider.scrollTo({ left: t * this.scrollMultiplier });
  }
  setSlideVisibility() {
    this.sliderItemsToShow.forEach((t, e) => {
      let i = t.querySelectorAll("a");
      e === this.currentPage - 1
        ? (i.length &&
            i.forEach((t2) => {
              t2.removeAttribute("tabindex");
            }),
          t.setAttribute("aria-hidden", "false"),
          t.removeAttribute("tabindex"))
        : (i.length &&
            i.forEach((t2) => {
              t2.setAttribute("tabindex", "-1");
            }),
          t.setAttribute("aria-hidden", "true"),
          t.setAttribute("tabindex", "-1"));
    });
  }
  linkToSlide(t) {
    t.preventDefault();
    let e = this.slider.scrollLeft * this.scrollMultiplier,
      i =
        e +
        this.sliderFirstItemNode.clientWidth *
          (this.sliderControlLinksArray.indexOf(t.currentTarget) +
            1 -
            this.currentPage);
    this.slider.scrollTo({ left: i * this.scrollMultiplier });
  }
}
function _defineProperties(t, e) {
  for (var i = 0; i < e.length; i++) {
    var s = e[i];
    (s.enumerable = s.enumerable || !1),
      (s.configurable = !0),
      "value" in s && (s.writable = !0),
      Object.defineProperty(t, s.key, s);
  }
}
function _createClass(t, e, i) {
  return (
    e && _defineProperties(t.prototype, e),
    i && _defineProperties(t, i),
    Object.defineProperty(t, "prototype", { writable: !1 }),
    t
  );
}
customElements.define("slideshow-component", SlideshowComponent),
  (function (t, e) {
    typeof exports == "object" && typeof module < "u"
      ? (module.exports = e())
      : typeof define == "function" && define.amd
      ? define(e)
      : ((t = typeof globalThis < "u" ? globalThis : t || self).Splide = e());
  })(this, function () {
    "use strict";
    var t = "(prefers-reduced-motion: reduce)";
    function e(t10) {
      t10.length = 0;
    }
    function i(t10, e2, i2) {
      return Array.prototype.slice.call(t10, e2, i2);
    }
    function s(t10) {
      return t10.bind.apply(t10, [null].concat(i(arguments, 1)));
    }
    var n = setTimeout,
      o = function () {};
    function r(t10) {
      return requestAnimationFrame(t10);
    }
    function a(t10, e2) {
      return typeof e2 === t10;
    }
    function l(t10) {
      return !p(t10) && a("object", t10);
    }
    var d = Array.isArray,
      c = s(a, "function"),
      u = s(a, "string"),
      h = s(a, "undefined");
    function p(t10) {
      return t10 === null;
    }
    function f(t10) {
      try {
        return (
          t10 instanceof (t10.ownerDocument.defaultView || window).HTMLElement
        );
      } catch {
        return !1;
      }
    }
    function v(t10) {
      return d(t10) ? t10 : [t10];
    }
    function m(t10, e2) {
      v(t10).forEach(e2);
    }
    function g(t10, e2) {
      return t10.indexOf(e2) > -1;
    }
    function y(t10, e2) {
      return t10.push.apply(t10, v(e2)), t10;
    }
    function b(t10, e2, i2) {
      t10 &&
        m(e2, function (e3) {
          e3 && t10.classList[i2 ? "add" : "remove"](e3);
        });
    }
    function $(t10, e2) {
      b(t10, u(e2) ? e2.split(" ") : e2, !0);
    }
    function S(t10, e2) {
      m(e2, t10.appendChild.bind(t10));
    }
    function E(t10, e2) {
      m(t10, function (t11) {
        var i2 = (e2 || t11).parentNode;
        i2 && i2.insertBefore(t11, e2);
      });
    }
    function L(t10, e2) {
      return f(t10) && (t10.msMatchesSelector || t10.matches).call(t10, e2);
    }
    function _(t10, e2) {
      var s2 = t10 ? i(t10.children) : [];
      return e2
        ? s2.filter(function (t11) {
            return L(t11, e2);
          })
        : s2;
    }
    function k(t10, e2) {
      return e2 ? _(t10, e2)[0] : t10.firstElementChild;
    }
    var x = Object.keys;
    function C(t10, e2, i2) {
      return (
        t10 &&
          (i2 ? x(t10).reverse() : x(t10)).forEach(function (i3) {
            i3 !== "__proto__" && e2(t10[i3], i3);
          }),
        t10
      );
    }
    function w(t10) {
      return (
        i(arguments, 1).forEach(function (e2) {
          C(e2, function (i2, s2) {
            t10[s2] = e2[s2];
          });
        }),
        t10
      );
    }
    function A(t10) {
      return (
        i(arguments, 1).forEach(function (e2) {
          C(e2, function (e3, i2) {
            d(e3)
              ? (t10[i2] = e3.slice())
              : l(e3)
              ? (t10[i2] = A({}, l(t10[i2]) ? t10[i2] : {}, e3))
              : (t10[i2] = e3);
          });
        }),
        t10
      );
    }
    function M(t10, e2) {
      m(e2 || x(t10), function (e3) {
        delete t10[e3];
      });
    }
    function B(t10, e2) {
      m(t10, function (t11) {
        m(e2, function (e3) {
          t11 && t11.removeAttribute(e3);
        });
      });
    }
    function P(t10, e2, i2) {
      l(e2)
        ? C(e2, function (e3, i3) {
            P(t10, i3, e3);
          })
        : m(t10, function (t11) {
            p(i2) || i2 === "" ? B(t11, e2) : t11.setAttribute(e2, String(i2));
          });
    }
    function T(t10, e2, i2) {
      var s2 = document.createElement(t10);
      return e2 && (u(e2) ? $(s2, e2) : P(s2, e2)), i2 && S(i2, s2), s2;
    }
    function q(t10, e2, i2) {
      if (h(i2)) return getComputedStyle(t10)[e2];
      p(i2) || (t10.style[e2] = "" + i2);
    }
    function D(t10, e2) {
      q(t10, "display", e2);
    }
    function I(t10) {
      (t10.setActive && t10.setActive()) || t10.focus({ preventScroll: !0 });
    }
    function O(t10, e2) {
      return t10.getAttribute(e2);
    }
    function H(t10, e2) {
      return t10 && t10.classList.contains(e2);
    }
    function N(t10) {
      return t10.getBoundingClientRect();
    }
    function R(t10) {
      m(t10, function (t11) {
        t11 && t11.parentNode && t11.parentNode.removeChild(t11);
      });
    }
    function W(t10) {
      return k(new DOMParser().parseFromString(t10, "text/html").body);
    }
    function F(t10, e2) {
      t10.preventDefault(),
        e2 && (t10.stopPropagation(), t10.stopImmediatePropagation());
    }
    function z(t10, e2) {
      return t10 && t10.querySelector(e2);
    }
    function V(t10, e2) {
      return e2 ? i(t10.querySelectorAll(e2)) : [];
    }
    function X(t10, e2) {
      b(t10, e2, !1);
    }
    function U(t10) {
      return t10.timeStamp;
    }
    function G(t10) {
      return u(t10) ? t10 : t10 ? t10 + "px" : "";
    }
    var j = "splide",
      Y = "data-" + j;
    function K(t10, e2) {
      if (!t10) throw Error("[" + j + "] " + (e2 || ""));
    }
    var J = Math.min,
      Q = Math.max,
      Z = Math.floor,
      tt = Math.ceil,
      te = Math.abs;
    function ti(t10, e2, i2) {
      return te(t10 - e2) < i2;
    }
    function ts(t10, e2, i2, s2) {
      var n2 = J(e2, i2),
        o2 = Q(e2, i2);
      return s2 ? n2 < t10 && t10 < o2 : n2 <= t10 && t10 <= o2;
    }
    function tn(t10, e2, i2) {
      var s2 = J(e2, i2),
        n2 = Q(e2, i2);
      return J(Q(s2, t10), n2);
    }
    function to(t10) {
      return +(t10 > 0) - +(t10 < 0);
    }
    function tr(t10, e2) {
      return (
        m(e2, function (e3) {
          t10 = t10.replace("%s", "" + e3);
        }),
        t10
      );
    }
    function ta(t10) {
      return t10 < 10 ? "0" + t10 : "" + t10;
    }
    var tl = {};
    function td() {
      var t10 = [];
      function i2(t11, e2, i3) {
        m(t11, function (t12) {
          t12 &&
            m(e2, function (e3) {
              e3.split(" ").forEach(function (e4) {
                var s2 = e4.split(".");
                i3(t12, s2[0], s2[1]);
              });
            });
        });
      }
      return {
        bind: function (s2, n2, o2, r2) {
          i2(s2, n2, function (e3, i3, s3) {
            var n3 = "addEventListener" in e3,
              a2 = n3
                ? e3.removeEventListener.bind(e3, i3, o2, r2)
                : e3.removeListener.bind(e3, o2);
            n3 ? e3.addEventListener(i3, o2, r2) : e3.addListener(o2),
              t10.push([e3, i3, s3, o2, a2]);
          });
        },
        unbind: function (s2, n2, o2) {
          i2(s2, n2, function (e3, i3, s3) {
            t10 = t10.filter(function (t11) {
              return (
                t11[0] !== e3 ||
                t11[1] !== i3 ||
                t11[2] !== s3 ||
                (!!o2 && t11[3] !== o2) ||
                (t11[4](), !1)
              );
            });
          });
        },
        dispatch: function (e2, i3, s2) {
          var n2;
          return (
            typeof CustomEvent == "function"
              ? (n2 = new CustomEvent(i3, { bubbles: !0, detail: s2 }))
              : (n2 = document.createEvent("CustomEvent")).initCustomEvent(
                  i3,
                  !0,
                  !1,
                  s2
                ),
            e2.dispatchEvent(n2),
            n2
          );
        },
        destroy: function () {
          t10.forEach(function (t11) {
            t11[4]();
          }),
            e(t10);
        },
      };
    }
    var tc = "mounted",
      tu = "ready",
      th = "move",
      tp = "moved",
      tf = "click",
      tv = "refresh",
      tm = "updated",
      tg = "resize",
      ty = "resized",
      tb = "scroll",
      t$ = "scrolled",
      tS = "destroy",
      tE = "navigation:mounted",
      tL = "autoplay:play",
      t_ = "autoplay:pause",
      tk = "lazyload:loaded";
    function tx(t10) {
      var e2 = t10 ? t10.event.bus : document.createDocumentFragment(),
        n2 = td();
      return (
        t10 && t10.event.on(tS, n2.destroy),
        w(n2, {
          bus: e2,
          on: function (i2, s2) {
            n2.bind(e2, v(i2).join(" "), function (t12) {
              s2.apply(s2, d(t12.detail) ? t12.detail : []);
            });
          },
          off: s(n2.unbind, e2),
          emit: function (s2) {
            n2.dispatch(e2, s2, i(arguments, 1));
          },
        })
      );
    }
    function tC(t10, e2, i2, s2) {
      var n2,
        o2,
        a2 = Date.now,
        l2 = 0,
        d2 = !0,
        c2 = 0;
      function u2() {
        if (!d2) {
          if (
            ((l2 = t10 ? J((a2() - n2) / t10, 1) : 1),
            i2 && i2(l2),
            l2 >= 1 && (e2(), (n2 = a2()), s2 && ++c2 >= s2))
          )
            return h2();
          o2 = r(u2);
        }
      }
      function h2() {
        d2 = !0;
      }
      function p2() {
        o2 && cancelAnimationFrame(o2), (l2 = 0), (o2 = 0), (d2 = !0);
      }
      function f2(e3) {
        t10 = e3;
      }
      function v2() {
        return d2;
      }
      return {
        start: function (i3) {
          i3 || p2(),
            (n2 = a2() - (i3 ? l2 * t10 : 0)),
            (d2 = !1),
            (o2 = r(u2));
        },
        rewind: function () {
          (n2 = a2()), (l2 = 0), i2 && i2(l2);
        },
        pause: h2,
        cancel: p2,
        set: f2,
        isPaused: v2,
      };
    }
    var tw = "Arrow",
      tA = tw + "Left",
      tM = tw + "Right",
      tB = tw + "Up",
      t8 = tw + "Down",
      tP = {
        width: ["height"],
        left: ["top", "right"],
        right: ["bottom", "left"],
        x: ["y"],
        X: ["Y"],
        Y: ["X"],
        ArrowLeft: [tB, tM],
        ArrowRight: [t8, tA],
      },
      tT = "role",
      tq = "tabindex",
      tD = "aria-",
      tI = tD + "controls",
      tO = tD + "current",
      tH = tD + "selected",
      tN = tD + "label",
      tR = tD + "labelledby",
      tW = tD + "hidden",
      tF = tD + "orientation",
      t2 = tD + "roledescription",
      tz = tD + "live",
      tV = tD + "busy",
      t3 = tD + "atomic",
      t9 = [tT, tq, "disabled", tI, tO, tN, tR, tW, tF, t2],
      tX = j + "__",
      t0 = j,
      t1 = tX + "track",
      t4 = tX + "list",
      tU = tX + "slide",
      tG = tU + "--clone",
      tj = tU + "__container",
      t6 = tX + "arrows",
      tY = tX + "arrow",
      t5 = tY + "--prev",
      t7 = tY + "--next",
      tK = tX + "pagination",
      tJ = tK + "__page",
      tQ = tX + "progress__bar",
      tZ = tX + "toggle",
      et = tX + "sr",
      ee = "is-active",
      ei = "is-prev",
      es = "is-next",
      en = "is-visible",
      eo = "is-loading",
      er = "is-focus-in",
      ea = "is-overflow",
      el = [ee, en, ei, es, eo, er, ea],
      ed = "touchstart mousedown",
      ec = "touchmove mousemove",
      eu = "touchend touchcancel mouseup click",
      eh = "slide",
      ep = "loop",
      ef = "fade",
      ev = Y + "-interval",
      em = { passive: !1, capture: !0 },
      eg = { Spacebar: " ", Right: tM, Left: tA, Up: tB, Down: t8 };
    function ey(t10) {
      return eg[(t10 = u(t10) ? t10 : t10.key)] || t10;
    }
    var eb = "keydown",
      e$ = Y + "-lazy",
      eS = e$ + "-srcset",
      eE = "[" + e$ + "], [" + eS + "]",
      eL = [" ", "Enter"],
      e_ = Object.freeze({
        __proto__: null,
        Media: function (i2, s2, n2) {
          var o2 = i2.state,
            r2 = n2.breakpoints || {},
            a2 = n2.reducedMotion || {},
            l2 = td(),
            d2 = [];
          function c2(t10) {
            t10 && l2.destroy();
          }
          function u2(t10, e3) {
            var i3 = matchMedia(e3);
            l2.bind(i3, "change", h2), d2.push([t10, i3]);
          }
          function h2() {
            var t10 = o2.is(7),
              e3 = n2.direction,
              s3 = d2.reduce(function (t11, e4) {
                return A(t11, e4[1].matches ? e4[0] : {});
              }, {});
            M(n2),
              p2(s3),
              n2.destroy
                ? i2.destroy(n2.destroy === "completely")
                : t10
                ? (c2(!0), i2.mount())
                : e3 !== n2.direction && i2.refresh();
          }
          function p2(t10, e3, s3) {
            A(n2, t10),
              e3 && A(Object.getPrototypeOf(n2), t10),
              (s3 || !o2.is(1)) && i2.emit(tm, n2);
          }
          return {
            setup: function () {
              var i3 = n2.mediaQuery === "min";
              x(r2)
                .sort(function (t10, e4) {
                  return i3 ? +t10 - +e4 : +e4 - +t10;
                })
                .forEach(function (t10) {
                  u2(
                    r2[t10],
                    "(" + (i3 ? "min" : "max") + "-width:" + t10 + "px)"
                  );
                }),
                u2(a2, t),
                h2();
            },
            destroy: c2,
            reduce: function (i3) {
              matchMedia(t).matches && (i3 ? A(n2, a2) : M(n2, x(a2)));
            },
            set: p2,
          };
        },
        Direction: function (e2, i2, s2) {
          return {
            resolve: function (e3, i3, n2) {
              var o2 =
                (n2 = n2 || s2.direction) !== "rtl" || i3
                  ? n2 === "ttb"
                    ? 0
                    : -1
                  : 1;
              return (
                (tP[e3] && tP[e3][o2]) ||
                e3.replace(/width|left|right/i, function (t12, e4) {
                  var i4 = tP[t12.toLowerCase()][o2] || t12;
                  return e4 > 0 ? i4.charAt(0).toUpperCase() + i4.slice(1) : i4;
                })
              );
            },
            orient: function (e3) {
              return e3 * (s2.direction === "rtl" ? 1 : -1);
            },
          };
        },
        Elements: function (i2, s2, n2) {
          var o2,
            r2,
            a2,
            l2 = tx(i2),
            d2 = l2.on,
            u2 = l2.bind,
            h2 = i2.root,
            p2 = n2.i18n,
            f2 = {},
            v2 = [],
            m2 = [],
            g2 = [];
          function S2() {
            var t11, e2, i3;
            (o2 = A2("." + t1)),
              (r2 = k(o2, "." + t4)),
              K(o2 && r2, "A track/list element is missing."),
              y(v2, _(r2, "." + tU + ":not(." + tG + ")")),
              C(
                {
                  arrows: t6,
                  pagination: tK,
                  prev: t5,
                  next: t7,
                  bar: tQ,
                  toggle: tZ,
                },
                function (t12, e3) {
                  f2[e3] = A2("." + t12);
                }
              ),
              w(f2, { root: h2, track: o2, list: r2, slides: v2 }),
              (e2 =
                h2.id || "" + (t11 = j) + ta((tl[t11] = (tl[t11] || 0) + 1))),
              (i3 = n2.role),
              (h2.id = e2),
              (o2.id = o2.id || e2 + "-track"),
              (r2.id = r2.id || e2 + "-list"),
              !O(h2, tT) && h2.tagName !== "SECTION" && i3 && P(h2, tT, i3),
              P(h2, t2, p2.carousel),
              P(r2, tT, "presentation"),
              x2();
          }
          function E2(t11) {
            var i3 = t9.concat("style");
            e(v2),
              X(h2, m2),
              X(o2, g2),
              B([o2, r2], i3),
              B(h2, t11 ? i3 : ["style", t2]);
          }
          function x2() {
            X(h2, m2),
              X(o2, g2),
              (m2 = M2(t0)),
              (g2 = M2(t1)),
              $(h2, m2),
              $(o2, g2),
              P(h2, tN, n2.label),
              P(h2, tR, n2.labelledby);
          }
          function A2(t11) {
            var e2 = z(h2, t11);
            return e2 &&
              (function (e3, i3) {
                if (c(e3.closest)) return e3.closest(i3);
                for (var s3 = e3; s3 && s3.nodeType === 1 && !L(s3, i3); )
                  s3 = s3.parentElement;
                return s3;
              })(e2, "." + t0) === h2
              ? e2
              : void 0;
          }
          function M2(t11) {
            return [
              t11 + "--" + n2.type,
              t11 + "--" + n2.direction,
              n2.drag && t11 + "--draggable",
              n2.isNavigation && t11 + "--nav",
              t11 === t0 && ee,
            ];
          }
          return w(f2, {
            setup: S2,
            mount: function () {
              d2(tv, E2),
                d2(tv, S2),
                d2(tm, x2),
                u2(
                  document,
                  ed + " keydown",
                  function (t12) {
                    a2 = t12.type === "keydown";
                  },
                  { capture: !0 }
                ),
                u2(h2, "focusin", function () {
                  b(h2, er, !!a2);
                });
            },
            destroy: E2,
          });
        },
        Slides: function (i2, n2, o2) {
          var r2 = tx(i2),
            a2 = r2.on,
            l2 = r2.emit,
            d2 = r2.bind,
            h2 = n2.Elements,
            p2 = h2.slides,
            y2 = h2.list,
            _2 = [];
          function x2() {
            p2.forEach(function (t11, e2) {
              w2(t11, e2, -1);
            });
          }
          function C2() {
            M2(function (t11) {
              t11.destroy();
            }),
              e(_2);
          }
          function w2(t11, e2, n3) {
            var o3 = (function (e3, i3, n4, o4) {
              var r3,
                a3 = tx(e3),
                l3 = a3.on,
                d3 = a3.emit,
                c2 = a3.bind,
                u2 = e3.Components,
                h3 = e3.root,
                p3 = e3.options,
                f2 = p3.isNavigation,
                v2 = p3.updateOnMove,
                m2 = p3.i18n,
                g2 = p3.pagination,
                y3 = p3.slideFocus,
                $2 = u2.Direction.resolve,
                S2 = O(o4, "style"),
                E2 = O(o4, tN),
                L2 = n4 > -1,
                _3 = k(o4, "." + tj);
              function x3() {
                var t13 = e3.splides
                  .map(function (t14) {
                    var e4 = t14.splide.Components.Slides.getAt(i3);
                    return e4 ? e4.slide.id : "";
                  })
                  .join(" ");
                P(o4, tN, tr(m2.slideX, (L2 ? n4 : i3) + 1)),
                  P(o4, tI, t13),
                  P(o4, tT, y3 ? "button" : ""),
                  y3 && B(o4, t2);
              }
              function C3() {
                r3 || w3();
              }
              function w3() {
                if (!r3) {
                  var t13,
                    s2 = e3.index;
                  (t13 = A3()) !== H(o4, ee) &&
                    (b(o4, ee, t13),
                    P(o4, tO, (f2 && t13) || ""),
                    d3(t13 ? "active" : "inactive", M3)),
                    (function () {
                      var i4 = (function () {
                          if (e3.is(ef)) return A3();
                          var i5 = N(u2.Elements.track),
                            s4 = N(o4),
                            n6 = $2("left", !0),
                            r4 = $2("right", !0);
                          return (
                            Z(i5[n6]) <= tt(s4[n6]) && Z(s4[r4]) <= tt(i5[r4])
                          );
                        })(),
                        s3 = !i4 && (!A3() || L2);
                      if (
                        (e3.state.is([4, 5]) || P(o4, tW, s3 || ""),
                        P(V(o4, p3.focusableNodes || ""), tq, s3 ? -1 : ""),
                        y3 && P(o4, tq, s3 ? -1 : 0),
                        i4 !== H(o4, en) &&
                          (b(o4, en, i4), d3(i4 ? "visible" : "hidden", M3)),
                        !i4 && document.activeElement === o4)
                      ) {
                        var n5 = u2.Slides.getAt(e3.index);
                        n5 && I(n5.slide);
                      }
                    })(),
                    b(o4, ei, i3 === s2 - 1),
                    b(o4, es, i3 === s2 + 1);
                }
              }
              function A3() {
                var t13 = e3.index;
                return t13 === i3 || (p3.cloneStatus && t13 === n4);
              }
              var M3 = {
                index: i3,
                slideIndex: n4,
                slide: o4,
                container: _3,
                isClone: L2,
                mount: function () {
                  L2 ||
                    ((o4.id = h3.id + "-slide" + ta(i3 + 1)),
                    P(o4, tT, g2 ? "tabpanel" : "group"),
                    P(o4, t2, m2.slide),
                    P(o4, tN, E2 || tr(m2.slideLabel, [i3 + 1, e3.length]))),
                    c2(o4, "click", s(d3, tf, M3)),
                    c2(o4, "keydown", s(d3, "sk", M3)),
                    l3([tp, "sh", t$], w3),
                    l3(tE, x3),
                    v2 && l3(th, C3);
                },
                destroy: function () {
                  (r3 = !0),
                    a3.destroy(),
                    X(o4, el),
                    B(o4, t9),
                    P(o4, "style", S2),
                    P(o4, tN, E2 || "");
                },
                update: w3,
                style: function (e4, i4, s2) {
                  q((s2 && _3) || o4, e4, i4);
                },
                isWithin: function (s2, n5) {
                  var o5 = te(s2 - i3);
                  return (
                    !L2 &&
                      (p3.rewind || e3.is(ep)) &&
                      (o5 = J(o5, e3.length - o5)),
                    o5 <= n5
                  );
                },
              };
              return M3;
            })(i2, e2, n3, t11);
            o3.mount(),
              _2.push(o3),
              _2.sort(function (t12, e3) {
                return t12.index - e3.index;
              });
          }
          function A2(t11) {
            return t11
              ? T2(function (t12) {
                  return !t12.isClone;
                })
              : _2;
          }
          function M2(t11, e2) {
            A2(e2).forEach(t11);
          }
          function T2(t11) {
            return _2.filter(
              c(t11)
                ? t11
                : function (e2) {
                    return u(t11) ? L(e2.slide, t11) : g(v(t11), e2.index);
                  }
            );
          }
          return {
            mount: function () {
              x2(), a2(tv, C2), a2(tv, x2);
            },
            destroy: C2,
            update: function () {
              M2(function (t12) {
                t12.update();
              });
            },
            register: w2,
            get: A2,
            getIn: function (e2) {
              var i3 = n2.Controller,
                s2 = i3.toIndex(e2),
                r3 = i3.hasFocus() ? 1 : o2.perPage;
              return T2(function (t12) {
                return ts(t12.index, s2, s2 + r3 - 1);
              });
            },
            getAt: function (e2) {
              return T2(e2)[0];
            },
            add: function (e2, i3) {
              m(e2, function (t12) {
                if ((u(t12) && (t12 = W(t12)), f(t12))) {
                  var e3,
                    n3,
                    r3,
                    a3,
                    c2 = p2[i3];
                  c2 ? E(t12, c2) : S(y2, t12),
                    $(t12, o2.classes.slide),
                    (e3 = t12),
                    (n3 = s(l2, tg)),
                    (a3 = (r3 = V(e3, "img")).length)
                      ? r3.forEach(function (t13) {
                          d2(t13, "load error", function () {
                            --a3 || n3();
                          });
                        })
                      : n3();
                }
              }),
                l2(tv);
            },
            remove: function (e2) {
              R(
                T2(e2).map(function (t12) {
                  return t12.slide;
                })
              ),
                l2(tv);
            },
            forEach: M2,
            filter: T2,
            style: function (e2, i3, s2) {
              M2(function (t12) {
                t12.style(e2, i3, s2);
              });
            },
            getLength: function (e2) {
              return e2 ? p2.length : _2.length;
            },
            isEnough: function () {
              return _2.length > o2.perPage;
            },
          };
        },
        Layout: function (e2, i2, n2) {
          var o2,
            r2,
            a2,
            d2 = tx(e2),
            c2 = d2.on,
            u2 = d2.bind,
            h2 = d2.emit,
            p2 = i2.Slides,
            f2 = i2.Direction.resolve,
            v2 = i2.Elements,
            m2 = v2.root,
            g2 = v2.track,
            y2 = v2.list,
            $2 = p2.getAt,
            S2 = p2.style;
          function E2() {
            (o2 = n2.direction === "ttb"),
              q(m2, "maxWidth", G(n2.width)),
              q(g2, f2("paddingLeft"), _2(!1)),
              q(g2, f2("paddingRight"), _2(!0)),
              L2(!0);
          }
          function L2(t11) {
            var e3,
              i3 = N(m2);
            (t11 || r2.width !== i3.width || r2.height !== i3.height) &&
              (q(
                g2,
                "height",
                ((e3 = ""),
                o2 &&
                  ((e3 = k2()),
                  K(e3, "height or heightRatio is missing."),
                  (e3 = "calc(" + e3 + " - " + _2(!1) + " - " + _2(!0) + ")")),
                e3)
              ),
              S2(f2("marginRight"), G(n2.gap)),
              S2(
                "width",
                n2.autoWidth ? null : G(n2.fixedWidth) || (o2 ? "" : x2())
              ),
              S2(
                "height",
                G(n2.fixedHeight) ||
                  (o2 ? (n2.autoHeight ? null : x2()) : k2()),
                !0
              ),
              (r2 = i3),
              h2(ty),
              a2 !== (a2 = P2()) && (b(m2, ea, a2), h2("overflow", a2)));
          }
          function _2(t11) {
            var e3 = n2.padding,
              i3 = f2(t11 ? "right" : "left");
            return (e3 && G(e3[i3] || (l(e3) ? 0 : e3))) || "0px";
          }
          function k2() {
            return G(n2.height || N(y2).width * n2.heightRatio);
          }
          function x2() {
            var t11 = G(n2.gap);
            return (
              "calc((100%" +
              (t11 && " + " + t11) +
              ")/" +
              (n2.perPage || 1) +
              (t11 && " - " + t11) +
              ")"
            );
          }
          function C2() {
            return N(y2)[f2("width")];
          }
          function w2(t11, e3) {
            var i3 = $2(t11 || 0);
            return i3 ? N(i3.slide)[f2("width")] + (e3 ? 0 : B2()) : 0;
          }
          function A2(t11, e3) {
            var i3 = $2(t11);
            if (i3) {
              var s2 = N(i3.slide)[f2("right")],
                n3 = N(y2)[f2("left")];
              return te(s2 - n3) + (e3 ? 0 : B2());
            }
            return 0;
          }
          function M2(t11) {
            return A2(e2.length - 1) - A2(0) + w2(0, t11);
          }
          function B2() {
            var t11 = $2(0);
            return (t11 && parseFloat(q(t11.slide, f2("marginRight")))) || 0;
          }
          function P2() {
            return e2.is(ef) || M2(!0) > C2();
          }
          return {
            mount: function () {
              var e3, i3;
              E2(),
                u2(
                  window,
                  "resize load",
                  ((e3 = s(h2, tg)),
                  (i3 = tC(0, e3, null, 1)),
                  function () {
                    i3.isPaused() && i3.start();
                  })
                ),
                c2([tm, tv], E2),
                c2(tg, L2);
            },
            resize: L2,
            listSize: C2,
            slideSize: w2,
            sliderSize: M2,
            totalSize: A2,
            getPadding: function (e3) {
              return (
                parseFloat(q(g2, f2("padding" + (e3 ? "Right" : "Left")))) || 0
              );
            },
            isOverflow: P2,
          };
        },
        Clones: function (i2, s2, n2) {
          var o2,
            r2 = tx(i2),
            a2 = r2.on,
            l2 = s2.Elements,
            d2 = s2.Slides,
            c2 = s2.Direction.resolve,
            u2 = [];
          function p2() {
            a2(tv, f2),
              a2([tm, tg], m2),
              (o2 = g2()) &&
                ((function (e2) {
                  var s3 = d2.get().slice(),
                    o3 = s3.length;
                  if (o3) {
                    for (; s3.length < e2; ) y(s3, s3);
                    y(s3.slice(-e2), s3.slice(0, e2)).forEach(function (
                      t12,
                      r3
                    ) {
                      var a3,
                        c3,
                        h2,
                        p3 = r3 < e2,
                        f3 =
                          ((a3 = t12.slide),
                          (c3 = r3),
                          (h2 = a3.cloneNode(!0)),
                          $(h2, n2.classes.clone),
                          (h2.id = i2.root.id + "-clone" + ta(c3 + 1)),
                          h2);
                      p3 ? E(f3, s3[0].slide) : S(l2.list, f3),
                        y(u2, f3),
                        d2.register(f3, r3 - e2 + (p3 ? 0 : o3), t12.index);
                    });
                  }
                })(o2),
                s2.Layout.resize(!0));
          }
          function f2() {
            v2(), p2();
          }
          function v2() {
            R(u2), e(u2), r2.destroy();
          }
          function m2() {
            var t11 = g2();
            o2 !== t11 && (o2 < t11 || !t11) && r2.emit(tv);
          }
          function g2() {
            var t11 = n2.clones;
            if (i2.is(ep)) {
              if (h(t11)) {
                var e2 = n2[c2("fixedWidth")] && s2.Layout.slideSize(0);
                t11 =
                  (e2 && tt(N(l2.track)[c2("width")] / e2)) ||
                  (n2[c2("autoWidth")] && i2.length) ||
                  2 * n2.perPage;
              }
            } else t11 = 0;
            return t11;
          }
          return { mount: p2, destroy: v2 };
        },
        Move: function (e2, i2, s2) {
          var n2,
            o2 = tx(e2),
            r2 = o2.on,
            a2 = o2.emit,
            l2 = e2.state.set,
            d2 = e2.state,
            c2 = i2.Layout,
            u2 = c2.slideSize,
            p2 = c2.getPadding,
            f2 = c2.totalSize,
            v2 = c2.listSize,
            m2 = c2.sliderSize,
            g2 = i2.Direction,
            y2 = g2.resolve,
            b2 = g2.orient,
            $2 = i2.Elements,
            S2 = $2.list,
            E2 = $2.track,
            L2 = 0;
          function _2() {
            return L2;
          }
          function k2() {
            i2.Controller.isBusy() ||
              (i2.Scroll.cancel(), x2(e2.index), i2.Slides.update());
          }
          function x2(t11) {
            C2(B2(t11, !0));
          }
          function C2(t11, n3) {
            if (!e2.is(ef)) {
              s2.paddingCalc &&
                s2.type === "slide" &&
                !d2.is(6) &&
                (L2 =
                  t11 >= -1 * s2.padding.right
                    ? 0
                    : m2() + t11 - s2.padding.right <= u2()
                    ? s2.padding.right
                    : s2.padding.right / 2);
              var o3 = n3
                ? t11
                : (function (s3) {
                    if (e2.is(ep)) {
                      var n4 = M2(s3),
                        o4 = n4 > i2.Controller.getEnd();
                      (n4 < 0 || o4) && (s3 = w2(s3, o4));
                    }
                    return s3;
                  })(t11);
              q(S2, "transform", `translate${y2("X")}(${o3 + L2}px)`),
                t11 !== o3 && a2("sh");
            }
          }
          function w2(t11, e3) {
            var i3 = t11 - T2(e3),
              s3 = m2();
            return t11 - b2(s3 * (tt(te(i3) / s3) || 1)) * (e3 ? 1 : -1);
          }
          function A2() {
            C2(P2(), !0), n2.cancel();
          }
          function M2(t11) {
            for (
              var e3 = i2.Slides.get(), s3 = 0, n3 = 1 / 0, o3 = 0;
              o3 < e3.length;
              o3++
            ) {
              var r3 = e3[o3].index,
                a3 = te(B2(r3, !0) - t11);
              if (a3 <= n3) (n3 = a3), (s3 = r3);
              else break;
            }
            return s3;
          }
          function B2(t11, i3) {
            var n3,
              o3,
              r3,
              a3 = b2(
                f2(t11 - 1) -
                  ((n3 = t11),
                  (o3 = s2.focus),
                  o3 === "center" ? (v2() - u2(n3, !0)) / 2 : +o3 * u2(n3) || 0)
              );
            return i3
              ? ((r3 = a3),
                s2.trimSpace &&
                  e2.is(eh) &&
                  (r3 = tn(r3, 0, b2(m2(!0) - v2()))),
                r3)
              : a3;
          }
          function P2() {
            var t11 = y2("left");
            return N(S2)[t11] - N(E2)[t11] + b2(p2(!1)) - L2;
          }
          function T2(t11) {
            return B2(t11 ? i2.Controller.getEnd() : 0, !!s2.trimSpace);
          }
          return {
            mount: function () {
              (n2 = i2.Transition), r2([tc, ty, tm, tv], k2);
            },
            move: function (e3, i3, s3, o3) {
              var r3, d3;
              e3 !== i3 &&
                ((r3 = e3 > s3),
                (d3 = b2(w2(P2(), r3))),
                r3
                  ? d3 >= 0
                  : d3 <= S2[y2("scrollWidth")] - N(E2)[y2("width")]) &&
                (A2(), C2(w2(P2(), e3 > s3), !0)),
                l2(4),
                a2(th, i3, s3, e3),
                n2.start(i3, function () {
                  l2(3), a2(tp, i3, s3, e3), o3 && o3();
                });
            },
            jump: x2,
            translate: C2,
            shift: w2,
            cancel: A2,
            toIndex: M2,
            toPosition: B2,
            getPosition: P2,
            getLimit: T2,
            exceededLimit: function (e3, i3) {
              i3 = h(i3) ? P2() : i3;
              var s3 = e3 !== !0 && b2(i3) < b2(T2(!1)),
                n3 = e3 !== !1 && b2(i3) > b2(T2(!0));
              return s3 || n3;
            },
            reposition: k2,
          };
        },
        Controller: function (e2, i2, n2) {
          var o2,
            r2,
            a2,
            l2,
            d2 = tx(e2),
            c2 = d2.on,
            p2 = d2.emit,
            f2 = i2.Move,
            v2 = f2.getPosition,
            m2 = f2.getLimit,
            g2 = f2.toPosition,
            y2 = i2.Slides,
            b2 = y2.isEnough,
            $2 = y2.getLength,
            S2 = n2.omitEnd,
            E2 = e2.is(ep),
            L2 = e2.is(eh),
            _2 = s(M2, !1),
            k2 = s(M2, !0),
            x2 = n2.start || 0,
            C2 = x2;
          function w2() {
            (r2 = $2(!0)), (a2 = n2.perMove), (l2 = n2.perPage), (o2 = T2());
            var t11 = tn(x2, 0, S2 ? o2 : r2 - 1);
            t11 !== x2 && ((x2 = t11), f2.reposition());
          }
          function A2() {
            o2 !== T2() && p2("ei");
          }
          function M2(t11, e3) {
            var i3,
              s2,
              n3 = a2 || (O2() ? 1 : l2),
              r3 = B2(x2 + n3 * (t11 ? -1 : 1), x2, !(a2 || O2()));
            return r3 === -1 &&
              L2 &&
              ((i3 = v2()), !(1 > te(i3 - (s2 = m2(!t11)))))
              ? t11
                ? 0
                : o2
              : e3
              ? r3
              : P2(r3);
          }
          function B2(t11, i3, s2) {
            if (b2() || O2()) {
              var d3 = (function (i4) {
                if (L2 && n2.trimSpace === "move" && i4 !== x2)
                  for (
                    var s3 = v2();
                    s3 === g2(i4, !0) && ts(i4, 0, e2.length - 1, !n2.rewind);

                  )
                    i4 < x2 ? --i4 : ++i4;
                return i4;
              })(t11);
              d3 !== t11 && ((i3 = t11), (t11 = d3), (s2 = !1)),
                t11 < 0 || t11 > o2
                  ? (t11 =
                      !a2 && (ts(0, t11, i3, !0) || ts(o2, i3, t11, !0))
                        ? q2(D2(t11))
                        : E2
                        ? s2
                          ? t11 < 0
                            ? -(r2 % l2 || l2)
                            : r2
                          : t11
                        : n2.rewind
                        ? t11 < 0
                          ? o2
                          : 0
                        : -1)
                  : s2 &&
                    t11 !== i3 &&
                    (t11 = q2(D2(i3) + (t11 < i3 ? -1 : 1)));
            } else t11 = -1;
            return t11;
          }
          function P2(t11) {
            return E2 ? (t11 + r2) % r2 || 0 : t11;
          }
          function T2() {
            for (
              var t11 = r2 - (O2() || (E2 && a2) ? 1 : l2);
              S2 && t11-- > 0;

            )
              if (g2(r2 - 1, !0) !== g2(t11, !0)) {
                t11++;
                break;
              }
            return tn(t11, 0, r2 - 1);
          }
          function q2(t11) {
            return tn(O2() ? t11 : l2 * t11, 0, o2);
          }
          function D2(t11) {
            return O2() ? J(t11, o2) : Z((t11 >= o2 ? r2 - 1 : t11) / l2);
          }
          function I2(t11) {
            t11 !== x2 && ((C2 = x2), (x2 = t11));
          }
          function O2() {
            return !h(n2.focus) || n2.isNavigation;
          }
          function H2() {
            return e2.state.is([4, 5]) && !!n2.waitForTransition;
          }
          return {
            mount: function () {
              w2(), c2([tm, tv, "ei"], w2), c2(ty, A2);
            },
            go: function (e3, i3, s2) {
              if (!H2()) {
                var n3 = (function (e4) {
                    var i4 = x2;
                    if (u(e4)) {
                      var s3 = e4.match(/([+\-<>])(\d+)?/) || [],
                        n4 = s3[1],
                        r4 = s3[2];
                      n4 === "+" || n4 === "-"
                        ? (i4 = B2(x2 + +("" + n4 + (+r4 || 1)), x2))
                        : n4 === ">"
                        ? (i4 = r4 ? q2(+r4) : _2(!0))
                        : n4 === "<" && (i4 = k2(!0));
                    } else i4 = E2 ? e4 : tn(e4, 0, o2);
                    return i4;
                  })(e3),
                  r3 = P2(n3);
                r3 > -1 &&
                  (i3 || r3 !== x2) &&
                  (I2(r3), f2.move(n3, r3, C2, s2));
              }
            },
            scroll: function (e3, s2, n3, r3) {
              i2.Scroll.scroll(e3, s2, n3, function () {
                var t12 = P2(f2.toIndex(v2()));
                I2(S2 ? J(t12, o2) : t12), r3 && r3();
              });
            },
            getNext: _2,
            getPrev: k2,
            getAdjacent: M2,
            getEnd: T2,
            setIndex: I2,
            getIndex: function (e3) {
              return e3 ? C2 : x2;
            },
            toIndex: q2,
            toPage: D2,
            toDest: function (e3) {
              var i3 = f2.toIndex(e3);
              return L2 ? tn(i3, 0, o2) : i3;
            },
            hasFocus: O2,
            isBusy: H2,
          };
        },
        Arrows: function (e2, i2, n2) {
          var o2,
            r2,
            a2 = tx(e2),
            l2 = a2.on,
            d2 = a2.bind,
            c2 = a2.emit,
            u2 = n2.classes,
            h2 = n2.i18n,
            p2 = i2.Elements,
            f2 = i2.Controller,
            v2 = p2.arrows,
            m2 = p2.track,
            g2 = v2,
            y2 = p2.prev,
            b2 = p2.next,
            L2 = {};
          function _2() {
            var t11;
            (t11 = n2.arrows) &&
              !(y2 && b2) &&
              ((g2 = v2 || T("div", u2.arrows)),
              (y2 = A2(!0)),
              (b2 = A2(!1)),
              (o2 = !0),
              S(g2, [y2, b2]),
              v2 || E(g2, m2)),
              y2 &&
                b2 &&
                (w(L2, { prev: y2, next: b2 }),
                D(g2, t11 ? "" : "none"),
                $(g2, (r2 = t6 + "--" + n2.direction)),
                t11 &&
                  (l2([tc, tp, tv, t$, "ei"], M2),
                  d2(b2, "click", s(C2, ">")),
                  d2(y2, "click", s(C2, "<")),
                  M2(),
                  P([y2, b2], tI, m2.id),
                  c2("arrows:mounted", y2, b2))),
              l2(tm, k2);
          }
          function k2() {
            x2(), _2();
          }
          function x2() {
            a2.destroy(),
              X(g2, r2),
              o2 ? (R(v2 ? [y2, b2] : g2), (y2 = b2 = null)) : B([y2, b2], t9);
          }
          function C2(t11) {
            f2.go(t11, !0);
          }
          function A2(t11) {
            return W(
              '<button class="' +
                u2.arrow +
                " " +
                (t11 ? u2.prev : u2.next) +
                '" type="button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" width="40" height="40" focusable="false"><path d="' +
                (n2.arrowPath ||
                  "m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z") +
                '" />'
            );
          }
          function M2() {
            if (y2 && b2) {
              var t11 = e2.index,
                i3 = f2.getPrev(),
                s2 = f2.getNext(),
                n3 = i3 > -1 && t11 < i3 ? h2.last : h2.prev,
                o3 = s2 > -1 && t11 > s2 ? h2.first : h2.next;
              (y2.disabled = i3 < 0),
                (b2.disabled = s2 < 0),
                P(y2, tN, n3),
                P(b2, tN, o3),
                c2("arrows:updated", y2, b2, i3, s2);
            }
          }
          return { arrows: L2, mount: _2, destroy: x2, update: M2 };
        },
        Autoplay: function (e2, i2, s2) {
          var n2,
            o2,
            r2 = tx(e2),
            a2 = r2.on,
            l2 = r2.bind,
            d2 = r2.emit,
            c2 = tC(s2.interval, e2.go.bind(e2, ">"), function (e3) {
              var i3 = h2.bar;
              i3 && q(i3, "width", 100 * e3 + "%"), d2("autoplay:playing", e3);
            }),
            u2 = c2.isPaused,
            h2 = i2.Elements,
            p2 = i2.Elements,
            f2 = p2.root,
            v2 = p2.toggle,
            m2 = s2.autoplay,
            g2 = m2 === "pause";
          function y2() {
            u2() &&
              i2.Slides.isEnough() &&
              (c2.start(!s2.resetProgress), (o2 = n2 = g2 = !1), E2(), d2(tL));
          }
          function $2(t11) {
            t11 === void 0 && (t11 = !0),
              (g2 = !!t11),
              E2(),
              u2() || (c2.pause(), d2(t_));
          }
          function S2() {
            g2 || (n2 || o2 ? $2(!1) : y2());
          }
          function E2() {
            v2 && (b(v2, ee, !g2), P(v2, tN, s2.i18n[g2 ? "play" : "pause"]));
          }
          function L2(t11) {
            var e3 = i2.Slides.getAt(t11);
            c2.set((e3 && +O(e3.slide, ev)) || s2.interval);
          }
          return {
            mount: function () {
              m2 &&
                (s2.pauseOnHover &&
                  l2(f2, "mouseenter mouseleave", function (t12) {
                    (n2 = t12.type === "mouseenter"), S2();
                  }),
                s2.pauseOnFocus &&
                  l2(f2, "focusin focusout", function (t12) {
                    (o2 = t12.type === "focusin"), S2();
                  }),
                v2 &&
                  l2(v2, "click", function () {
                    g2 ? y2() : $2(!0);
                  }),
                a2([th, tb, tv], c2.rewind),
                a2(th, L2),
                v2 && P(v2, tI, h2.track.id),
                g2 || y2(),
                E2());
            },
            destroy: c2.cancel,
            play: y2,
            pause: $2,
            isPaused: u2,
          };
        },
        Cover: function (e2, i2, n2) {
          var o2 = tx(e2).on;
          function r2(t11) {
            i2.Slides.forEach(function (e3) {
              var i3 = k(e3.container || e3.slide, "img");
              i3 && i3.src && a2(t11, i3, e3);
            });
          }
          function a2(t11, e3, i3) {
            i3.style(
              "background",
              t11 ? 'center/cover no-repeat url("' + e3.src + '")' : "",
              !0
            ),
              D(e3, t11 ? "none" : "");
          }
          return {
            mount: function () {
              n2.cover && (o2(tk, s(a2, !0)), o2([tc, tm, tv], s(r2, !0)));
            },
            destroy: s(r2, !1),
          };
        },
        Scroll: function (e2, i2, n2) {
          var o2,
            r2,
            a2 = tx(e2),
            l2 = a2.on,
            d2 = a2.emit,
            c2 = e2.state.set,
            u2 = i2.Move,
            h2 = u2.getPosition,
            p2 = u2.getLimit,
            f2 = u2.exceededLimit,
            v2 = u2.translate,
            m2 = e2.is(eh),
            g2 = 1;
          function y2(t11, e3, n3, a3, l3) {
            var p3 = h2();
            if ((S2(), n3 && (!m2 || !f2()))) {
              var v3 = i2.Layout.sliderSize(),
                y3 = to(t11) * v3 * Z(te(t11) / v3) || 0;
              t11 = u2.toPosition(i2.Controller.toDest(t11 % v3)) + y3;
            }
            var E3,
              L2,
              _2 = ((E3 = p3), (L2 = t11), 1 > te(E3 - L2));
            (g2 = 1),
              (e3 = _2 ? 0 : e3 || Q(te(t11 - p3) / 1.5, 800)),
              (r2 = a3),
              (o2 = tC(e3, b2, s($2, p3, t11, l3), 1)),
              c2(5),
              d2(tb),
              o2.start();
          }
          function b2() {
            c2(3), r2 && r2(), d2(t$);
          }
          function $2(t11, e3, i3, s2) {
            var o3,
              a3,
              l3 = h2(),
              d3 =
                (t11 +
                  (e3 - t11) *
                    ((o3 = s2),
                    (a3 = n2.easingFunc),
                    a3 ? a3(o3) : 1 - Math.pow(1 - o3, 4)) -
                  l3) *
                g2;
            v2(l3 + d3),
              m2 &&
                !i3 &&
                f2() &&
                ((g2 *= 0.6), 10 > te(d3) && y2(p2(f2(!0)), 600, !1, r2, !0));
          }
          function S2() {
            o2 && o2.cancel();
          }
          function E2() {
            o2 && !o2.isPaused() && (S2(), b2());
          }
          return {
            mount: function () {
              l2(th, S2), l2([tm, tv], E2);
            },
            destroy: S2,
            scroll: y2,
            cancel: E2,
          };
        },
        Drag: function (e2, i2, s2) {
          var n2,
            r2,
            a2,
            d2,
            c2,
            u2,
            h2,
            p2,
            f2 = tx(e2),
            v2 = f2.on,
            m2 = f2.emit,
            g2 = f2.bind,
            y2 = f2.unbind,
            b2 = e2.state,
            $2 = i2.Move,
            S2 = i2.Scroll,
            E2 = i2.Controller,
            _2 = i2.Elements.track,
            k2 = i2.Media.reduce,
            x2 = i2.Direction,
            C2 = x2.resolve,
            w2 = x2.orient,
            A2 = $2.getPosition,
            M2 = $2.exceededLimit,
            B2 = !1;
          function P2() {
            var t11,
              e3 = s2.drag;
            (h2 = t11 = !e3), (d2 = e3 === "free");
          }
          function T2(t11) {
            if (((u2 = !1), !h2)) {
              var e3,
                i3,
                n3 = z2(t11);
              (e3 = t11.target),
                (i3 = s2.noDrag),
                L(e3, "." + tJ + ", ." + tY) ||
                  (i3 && L(e3, i3)) ||
                  (!n3 && t11.button) ||
                  (E2.isBusy()
                    ? F(t11, !0)
                    : ((p2 = n3 ? _2 : window),
                      (c2 = b2.is([4, 5])),
                      (a2 = null),
                      g2(p2, ec, q2, em),
                      g2(p2, eu, D2, em),
                      $2.cancel(),
                      S2.cancel(),
                      O2(t11)));
            }
          }
          function q2(t11) {
            if ((b2.is(6) || (b2.set(6), m2("drag")), t11.cancelable))
              if (c2) {
                $2.translate(
                  n2 + ((p3 = H2(t11)), p3 / (B2 && e2.is(eh) ? 5 : 1))
                );
                var i3,
                  o2,
                  r3,
                  a3,
                  d3,
                  h3,
                  p3,
                  f3 = N2(t11) > 200,
                  v3 = B2 !== (B2 = M2());
                (f3 || v3) && O2(t11), (u2 = !0), m2("dragging"), F(t11);
              } else
                (i3 = t11),
                  te(H2(i3)) > te(H2(i3, !0)) &&
                    ((c2 =
                      ((o2 = t11),
                      (r3 = s2.dragMinThreshold),
                      (a3 = l(r3)),
                      (d3 = (a3 && r3.mouse) || 0),
                      (h3 = (a3 ? r3.touch : +r3) || 10),
                      te(H2(o2)) > (z2(o2) ? h3 : d3))),
                    F(t11));
          }
          function D2(t11) {
            var n3, o2, r3, a3, l2;
            b2.is(6) && (b2.set(3), m2("dragged")),
              c2 &&
                ((a3 =
                  ((o2 = r3 =
                    (function (i3) {
                      if (e2.is(ep) || !B2) {
                        var s3 = N2(i3);
                        if (s3 && s3 < 200) return H2(i3) / s3;
                      }
                      return 0;
                    })((n3 = t11))),
                  A2() +
                    to(o2) *
                      J(
                        te(o2) * (s2.flickPower || 600),
                        d2
                          ? 1 / 0
                          : i2.Layout.listSize() * (s2.flickMaxPages || 1)
                      ))),
                (l2 = s2.rewind && s2.rewindByDrag),
                k2(!1),
                d2
                  ? E2.scroll(a3, 0, s2.snap)
                  : e2.is(ef)
                  ? E2.go(0 > w2(to(r3)) ? (l2 ? "<" : "-") : l2 ? ">" : "+")
                  : e2.is(eh) && B2 && l2
                  ? E2.go(M2(!0) ? ">" : "<")
                  : E2.go(E2.toDest(a3), !0),
                k2(!0),
                F(t11)),
              y2(p2, ec, q2),
              y2(p2, eu, D2),
              (c2 = !1);
          }
          function I2(t11) {
            !h2 && u2 && F(t11, !0);
          }
          function O2(t11) {
            (a2 = r2), (r2 = t11), (n2 = A2());
          }
          function H2(t11, e3) {
            return W2(t11, e3) - W2(R2(t11), e3);
          }
          function N2(t11) {
            return U(t11) - U(R2(t11));
          }
          function R2(t11) {
            return (r2 === t11 && a2) || r2;
          }
          function W2(t11, e3) {
            return (z2(t11) ? t11.changedTouches[0] : t11)[
              "page" + C2(e3 ? "Y" : "X")
            ];
          }
          function z2(t11) {
            return typeof TouchEvent < "u" && t11 instanceof TouchEvent;
          }
          function V2() {
            return c2;
          }
          function X2(t11) {
            h2 = t11;
          }
          return {
            mount: function () {
              g2(_2, ec, o, em),
                g2(_2, eu, o, em),
                g2(_2, ed, T2, em),
                g2(_2, "click", I2, { capture: !0 }),
                g2(_2, "dragstart", F),
                v2([tc, tm], P2);
            },
            disable: X2,
            isDragging: V2,
          };
        },
        Keyboard: function (e2, i2, s2) {
          var o2,
            r2,
            a2 = tx(e2),
            l2 = a2.on,
            d2 = a2.bind,
            c2 = a2.unbind,
            u2 = e2.root,
            h2 = i2.Direction.resolve;
          function p2() {
            var t11 = s2.keyboard;
            t11 && d2((o2 = t11 === "global" ? window : u2), eb, g2);
          }
          function f2() {
            c2(o2, eb);
          }
          function v2(t11) {
            r2 = t11;
          }
          function m2() {
            var t11 = r2;
            (r2 = !0),
              n(function () {
                r2 = t11;
              });
          }
          function g2(t11) {
            if (!r2) {
              var i3 = ey(t11);
              i3 === h2(tA) ? e2.go("<") : i3 === h2(tM) && e2.go(">");
            }
          }
          return {
            mount: function () {
              p2(), l2(tm, f2), l2(tm, p2), l2(th, m2);
            },
            destroy: f2,
            disable: v2,
          };
        },
        LazyLoad: function (i2, n2, o2) {
          var r2 = tx(i2),
            a2 = r2.on,
            l2 = r2.off,
            d2 = r2.bind,
            c2 = r2.emit,
            u2 = o2.lazyLoad === "sequential",
            h2 = [tp, t$],
            p2 = [];
          function f2() {
            e(p2),
              n2.Slides.forEach(function (t11) {
                V(t11.slide, eE).forEach(function (e2) {
                  var i3 = O(e2, e$),
                    s2 = O(e2, eS);
                  if (i3 !== e2.src || s2 !== e2.srcset) {
                    var n3 = o2.classes.spinner,
                      r3 = e2.parentElement,
                      a3 = k(r3, "." + n3) || T("span", n3, r3);
                    p2.push([e2, t11, a3]), e2.src || D(e2, "none");
                  }
                });
              }),
              u2 ? y2() : (l2(h2), a2(h2, v2), v2());
          }
          function v2() {
            (p2 = p2.filter(function (t11) {
              var e2 = o2.perPage * ((o2.preloadPages || 1) + 1) - 1;
              return !t11[1].isWithin(i2.index, e2) || m2(t11);
            })).length || l2(h2);
          }
          function m2(t11) {
            var e2 = t11[0];
            $(t11[1].slide, eo),
              d2(e2, "load error", s(g2, t11)),
              P(e2, "src", O(e2, e$)),
              P(e2, "srcset", O(e2, eS)),
              B(e2, e$),
              B(e2, eS);
          }
          function g2(t11, e2) {
            var i3 = t11[0],
              s2 = t11[1];
            X(s2.slide, eo),
              e2.type !== "error" &&
                (R(t11[2]), D(i3, ""), c2(tk, i3, s2), c2(tg)),
              u2 && y2();
          }
          function y2() {
            p2.length && m2(p2.shift());
          }
          return {
            mount: function () {
              o2.lazyLoad && (f2(), a2(tv, f2));
            },
            destroy: s(e, p2),
            check: v2,
          };
        },
        Pagination: function (n2, o2, r2) {
          var a2,
            l2,
            d2 = tx(n2),
            c2 = d2.on,
            u2 = d2.emit,
            h2 = d2.bind,
            p2 = o2.Slides,
            f2 = o2.Elements,
            v2 = o2.Controller,
            m2 = v2.hasFocus,
            g2 = v2.getIndex,
            y2 = v2.go,
            b2 = o2.Direction.resolve,
            S2 = f2.pagination,
            E2 = [];
          function L2() {
            _2(), c2([tm, tv, "ei"], L2);
            var t11 = r2.pagination;
            S2 && D(S2, t11 ? "" : "none"),
              t11 &&
                (c2([th, tb, t$], A2),
                (function () {
                  var e2 = n2.length,
                    i2 = r2.classes,
                    o3 = r2.i18n,
                    d3 = r2.perPage,
                    c3 = m2() ? v2.getEnd() + 1 : tt(e2 / d3);
                  (a2 = S2 || T("ul", i2.pagination, f2.track.parentElement)),
                    $(a2, (l2 = tK + "--" + C2())),
                    P(a2, tT, "tablist"),
                    P(a2, tN, o3.select),
                    P(a2, tF, C2() === "ttb" ? "vertical" : "");
                  for (var u3 = 0; u3 < c3; u3++) {
                    var g3 = T("li", null, a2),
                      y3 = T("button", { class: i2.page, type: "button" }, g3),
                      b3 = p2.getIn(u3).map(function (t13) {
                        return t13.slide.id;
                      }),
                      L3 = !m2() && d3 > 1 ? o3.pageX : o3.slideX;
                    h2(y3, "click", s(k2, u3)),
                      r2.paginationKeyboard && h2(y3, "keydown", s(x2, u3)),
                      P(g3, tT, "presentation"),
                      P(y3, tT, "tab"),
                      P(y3, tI, b3.join(" ")),
                      P(y3, tN, tr(L3, u3 + 1)),
                      P(y3, tq, -1),
                      E2.push({ li: g3, button: y3, page: u3 });
                  }
                })(),
                A2(),
                u2(
                  "pagination:mounted",
                  { list: a2, items: E2 },
                  w2(n2.index)
                ));
          }
          function _2() {
            a2 && (R(S2 ? i(a2.children) : a2), X(a2, l2), e(E2), (a2 = null)),
              d2.destroy();
          }
          function k2(t11) {
            y2(">" + t11, !0);
          }
          function x2(t11, e2) {
            var i2 = E2.length,
              s2 = ey(e2),
              n3 = C2(),
              o3 = -1;
            s2 === b2(tM, !1, n3)
              ? (o3 = ++t11 % i2)
              : s2 === b2(tA, !1, n3)
              ? (o3 = (--t11 + i2) % i2)
              : s2 === "Home"
              ? (o3 = 0)
              : s2 === "End" && (o3 = i2 - 1);
            var r3 = E2[o3];
            r3 && (I(r3.button), y2(">" + o3), F(e2, !0));
          }
          function C2() {
            return r2.paginationDirection || r2.direction;
          }
          function w2(t11) {
            return E2[v2.toPage(t11)];
          }
          function A2() {
            var t11 = w2(g2(!0)),
              e2 = w2(g2());
            if (t11) {
              var i2 = t11.button;
              X(i2, ee), B(i2, tH), P(i2, tq, -1);
            }
            if (e2) {
              var s2 = e2.button;
              $(s2, ee), P(s2, tH, !0), P(s2, tq, "");
            }
            u2("pagination:updated", { list: a2, items: E2 }, t11, e2);
          }
          return { items: E2, mount: L2, destroy: _2, getAt: w2, update: A2 };
        },
        Sync: function (i2, n2, o2) {
          var r2 = o2.isNavigation,
            a2 = o2.slideFocus,
            l2 = [];
          function d2() {
            var t11, e2;
            i2.splides.forEach(function (t12) {
              t12.isParent || (u2(i2, t12.splide), u2(t12.splide, i2));
            }),
              r2 &&
                ((t11 = tx(i2)),
                (e2 = t11.on),
                e2(tf, f2),
                e2("sk", v2),
                e2([tc, tm], p2),
                l2.push(t11),
                t11.emit(tE, i2.splides));
          }
          function c2() {
            l2.forEach(function (t11) {
              t11.destroy();
            }),
              e(l2);
          }
          function u2(t11, e2) {
            var i3 = tx(t11);
            i3.on(th, function (t12, i4, s2) {
              e2.go(e2.is(ep) ? s2 : t12);
            }),
              l2.push(i3);
          }
          function p2() {
            P(n2.Elements.list, tF, o2.direction === "ttb" ? "vertical" : "");
          }
          function f2(t11) {
            i2.go(t11.index);
          }
          function v2(t11, e2) {
            g(eL, ey(e2)) && (f2(t11), F(e2));
          }
          return {
            setup: s(n2.Media.set, { slideFocus: h(a2) ? r2 : a2 }, !0),
            mount: d2,
            destroy: c2,
            remount: function () {
              c2(), d2();
            },
          };
        },
        Wheel: function (e2, i2, s2) {
          var n2 = tx(e2).bind,
            o2 = 0;
          function r2(t11) {
            if (t11.cancelable) {
              var n3,
                r3 = t11.deltaY,
                a2 = r3 < 0,
                l2 = U(t11),
                d2 = s2.wheelMinThreshold || 0,
                c2 = s2.wheelSleep || 0;
              te(r3) > d2 && l2 - o2 > c2 && (e2.go(a2 ? "<" : ">"), (o2 = l2)),
                (n3 = a2),
                (!s2.releaseWheel ||
                  e2.state.is(4) ||
                  i2.Controller.getAdjacent(n3) !== -1) &&
                  F(t11);
            }
          }
          return {
            mount: function () {
              s2.wheel && n2(i2.Elements.track, "wheel", r2, em);
            },
          };
        },
        Live: function (e2, i2, n2) {
          var o2 = tx(e2).on,
            r2 = i2.Elements.track,
            a2 = n2.live && !n2.isNavigation,
            l2 = T("span", et),
            d2 = tC(90, s(c2, !1));
          function c2(t11) {
            P(r2, tV, t11),
              t11 ? (S(r2, l2), d2.start()) : (R(l2), d2.cancel());
          }
          function u2(t11) {
            a2 && P(r2, tz, t11 ? "off" : "polite");
          }
          return {
            mount: function () {
              a2 &&
                (u2(!i2.Autoplay.isPaused()),
                P(r2, t3, !0),
                (l2.textContent = "\u2026"),
                o2(tL, s(u2, !0)),
                o2(t_, s(u2, !1)),
                o2([tp, t$], s(c2, !0)));
            },
            disable: u2,
            destroy: function () {
              B(r2, [tz, t3, tV]), R(l2);
            },
          };
        },
      }),
      ek = {
        type: "slide",
        role: "region",
        speed: 400,
        perPage: 1,
        cloneStatus: !0,
        arrows: !0,
        pagination: !0,
        paginationKeyboard: !0,
        interval: 5e3,
        pauseOnHover: !0,
        pauseOnFocus: !0,
        resetProgress: !0,
        easing: "cubic-bezier(0.25, 1, 0.5, 1)",
        drag: !0,
        direction: "ltr",
        trimSpace: !0,
        focusableNodes: "a, button, textarea, input, select, iframe",
        live: !0,
        classes: {
          slide: tU,
          clone: tG,
          arrows: t6,
          arrow: tY,
          prev: t5,
          next: t7,
          pagination: tK,
          page: tJ,
          spinner: tX + "spinner",
        },
        i18n: {
          prev: "Previous slide",
          next: "Next slide",
          first: "Go to first slide",
          last: "Go to last slide",
          slideX: "Go to slide %s",
          pageX: "Go to page %s",
          play: "Start autoplay",
          pause: "Pause autoplay",
          carousel: "carousel",
          slide: "slide",
          select: "Select a slide to show",
          slideLabel: "%s of %s",
        },
        reducedMotion: { speed: 0, rewindSpeed: 0, autoplay: "pause" },
      };
    function ex(t10, e2, i2) {
      var s2 = e2.Slides;
      function r2() {
        s2.forEach(function (t11) {
          t11.style("transform", "translateX(-" + 100 * t11.index + "%)");
        });
      }
      return {
        mount: function () {
          tx(t10).on([tc, tv], r2);
        },
        start: function (e3, o2) {
          s2.style("transition", "opacity " + i2.speed + "ms " + i2.easing),
            n(o2);
        },
        cancel: o,
      };
    }
    function eC(t10, e2, i2) {
      var n2,
        o2 = e2.Move,
        r2 = e2.Controller,
        a2 = e2.Scroll,
        l2 = e2.Elements.list,
        d2 = s(q, l2, "transition");
      function c2() {
        d2(""), a2.cancel();
      }
      return {
        mount: function () {
          tx(t10).bind(l2, "transitionend", function (t11) {
            t11.target === l2 && n2 && (c2(), n2());
          });
        },
        start: function (s2, l3) {
          var c3 = o2.toPosition(s2, !0),
            u2 = o2.getPosition(),
            h2 = (function (s3) {
              var n3 = i2.rewindSpeed;
              if (t10.is(eh) && n3) {
                var o3 = r2.getIndex(!0),
                  a3 = r2.getEnd();
                if ((o3 === 0 && s3 >= a3) || (o3 >= a3 && s3 === 0)) return n3;
              }
              return i2.speed;
            })(s2);
          te(c3 - u2) >= 1 && h2 >= 1
            ? i2.useScroll
              ? a2.scroll(c3, h2, !1, l3)
              : (d2("transform " + h2 + "ms " + i2.easing),
                o2.translate(c3, !0),
                (n2 = l3))
            : (o2.jump(s2), l3());
        },
        cancel: c2,
      };
    }
    var ew = (function () {
      function t10(e2, i2) {
        (this.event = tx()),
          (this.Components = {}),
          (this.state = (function (e3) {
            var i3 = 1;
            function s4(t12) {
              i3 = t12;
            }
            return {
              set: s4,
              is: function (e4) {
                return g(v(e4), i3);
              },
            };
          })(1)),
          (this.splides = []),
          (this._o = {}),
          (this._E = {});
        var s3 = u(e2) ? z(document, e2) : e2;
        K(s3, s3 + " is invalid."),
          (this.root = s3),
          (i2 = A(
            { label: O(s3, tN) || "", labelledby: O(s3, tR) || "" },
            ek,
            t10.defaults,
            i2 || {}
          ));
        try {
          A(i2, JSON.parse(O(s3, Y)));
        } catch {
          K(!1, "Invalid JSON");
        }
        this._o = Object.create(A({}, i2));
      }
      var s2 = t10.prototype;
      return (
        (s2.mount = function (e2, i2) {
          var s3 = this,
            n2 = this.state,
            o2 = this.Components;
          K(n2.is([1, 7]), "Already mounted!"),
            n2.set(1),
            (this._C = o2),
            (this._T = i2 || this._T || (this.is(ef) ? ex : eC)),
            (this._E = e2 || this._E);
          var r2 = w({}, e_, this._E, { Transition: this._T });
          return (
            C(r2, function (t12, e3) {
              var i3 = t12(s3, o2, s3._o);
              (o2[e3] = i3), i3.setup && i3.setup();
            }),
            C(o2, function (t12) {
              t12.mount && t12.mount();
            }),
            this.emit(tc),
            $(this.root, "is-initialized"),
            n2.set(3),
            this.emit(tu),
            this
          );
        }),
        (s2.sync = function (e2) {
          return (
            this.splides.push({ splide: e2 }),
            e2.splides.push({ splide: this, isParent: !0 }),
            this.state.is(3) &&
              (this._C.Sync.remount(), e2.Components.Sync.remount()),
            this
          );
        }),
        (s2.go = function (e2) {
          return this._C.Controller.go(e2), this;
        }),
        (s2.on = function (e2, i2) {
          return this.event.on(e2, i2), this;
        }),
        (s2.off = function (e2) {
          return this.event.off(e2), this;
        }),
        (s2.emit = function (e2) {
          var s3;
          return (
            (s3 = this.event).emit.apply(s3, [e2].concat(i(arguments, 1))), this
          );
        }),
        (s2.add = function (e2, i2) {
          return this._C.Slides.add(e2, i2), this;
        }),
        (s2.remove = function (e2) {
          return this._C.Slides.remove(e2), this;
        }),
        (s2.is = function (e2) {
          return this._o.type === e2;
        }),
        (s2.refresh = function () {
          return this.emit(tv), this;
        }),
        (s2.destroy = function (i2) {
          i2 === void 0 && (i2 = !0);
          var s3 = this.event,
            n2 = this.state;
          return (
            n2.is(1)
              ? tx(this).on(tu, this.destroy.bind(this, i2))
              : (C(
                  this._C,
                  function (t12) {
                    t12.destroy && t12.destroy(i2);
                  },
                  !0
                ),
                s3.emit(tS),
                s3.destroy(),
                i2 && e(this.splides),
                n2.set(7)),
            this
          );
        }),
        _createClass(t10, [
          {
            key: "options",
            get: function () {
              return this._o;
            },
            set: function (e2) {
              this._C.Media.set(e2, !0, !0);
            },
          },
          {
            key: "length",
            get: function () {
              return this._C.Slides.getLength(!0);
            },
          },
          {
            key: "index",
            get: function () {
              return this._C.Controller.getIndex();
            },
          },
        ]),
        t10
      );
    })();
    return (
      (ew.defaults = {}),
      (ew.STATES = {
        CREATED: 1,
        MOUNTED: 2,
        IDLE: 3,
        MOVING: 4,
        SCROLLING: 5,
        DRAGGING: 6,
        DESTROYED: 7,
      }),
      ew
    );
  });
class SplideComponent extends HTMLElement {
  constructor() {
    super(),
      (this.sliderContainer = this.querySelector(".splide")),
      document.addEventListener("shopify:section:load", (t) => {
        this.initSlider();
      });
  }
  connectedCallback() {
    this.initSlider();
  }
  initSlider() {
    (this.type = this.dataset.type || "slide"),
      (this.typeMobile = this.dataset.typeMobile || this.type),
      (this.direction = this.dataset.direction || defaultDirection),
      (this.rewind = this.type === "fade"),
      (this.autoplay = this.dataset.autoplay === "true"),
      (this.autoplaySpeed =
        this.dataset.autoplaySpeed &&
        !isNaN(parseInt(this.dataset.autoplaySpeed))
          ? 1e3 * parseInt(this.dataset.autoplaySpeed)
          : 5e3),
      (this.drag =
        this.dataset.drag !== "false" &&
        (this.dataset.drag !== "free" || "free")),
      (this.focus = this.dataset.focus || 0),
      (this.trimSpace = this.dataset.trimSpace !== "false"),
      (this.arrows = this.dataset.arrows !== "false"),
      (this.arrowsColor = this.dataset.arrowsColor
        ? ` color-${this.dataset.arrowsColor}`
        : ""),
      (this.pagination = this.dataset.pagination !== "false"),
      (this.omitEnd = this.dataset.omitEnd !== "false"),
      (this.dotsColor = this.dataset.dotsColor
        ? ` color-${this.dataset.dotsColor} dots-custom-color`
        : ""),
      (this.slidesDesktop =
        this.dataset.slidesDesktop &&
        !isNaN(parseInt(this.dataset.slidesDesktop))
          ? parseInt(this.dataset.slidesDesktop)
          : 3),
      (this.autoWidth = this.dataset.autoWidth === "true"),
      (this.slidesMobile =
        this.dataset.slidesMobile && !isNaN(parseInt(this.dataset.slidesMobile))
          ? parseInt(this.dataset.slidesMobile)
          : 1),
      (this.perMoveDesktop =
        this.dataset.perMoveDesktop &&
        !isNaN(parseInt(this.dataset.perMoveDesktop))
          ? parseInt(this.dataset.perMoveDesktop)
          : 1),
      (this.perMoveMobile =
        this.dataset.perMoveMobile &&
        !isNaN(parseInt(this.dataset.perMoveMobile))
          ? parseInt(this.dataset.perMoveMobile)
          : 1),
      (this.gapDesktop = this.dataset.gapDesktop
        ? parseInt(this.dataset.gapDesktop)
        : 30),
      (this.gapMobile = this.dataset.gapMobile
        ? parseInt(this.dataset.gapMobile)
        : 15),
      (this.paddingCalcDesktop = this.dataset.paddingCalcDesktop === "true"),
      (this.rightPaddingDesktop =
        parseInt(this.dataset.sidePaddingDesktop) || 0),
      (this.leftPaddingDesktop = this.dataset.paddingCalcDesktop
        ? 0
        : this.rightPaddingDesktop),
      (this.paddingCalcMobile = this.dataset.paddingCalcMobile === "true"),
      (this.rightPaddingMobile = parseInt(this.dataset.sidePaddingMobile) || 0),
      (this.leftPaddingMobile = this.paddingCalcMobile
        ? 0
        : this.rightPaddingMobile),
      (this.destroyDesktop = this.dataset.destroyDesktop === "true"),
      (this.destroyMobile = this.dataset.destroyMobile === "true"),
      (this.config = {
        type: this.type,
        direction: this.direction,
        rewind: this.rewind,
        autoplay: this.autoplay,
        interval: this.autoplaySpeed,
        drag: this.drag,
        focus: this.focus,
        trimSpace: this.trimSpace,
        arrows: this.arrows,
        pagination: this.pagination,
        omitEnd: this.omitEnd,
        perPage: this.slidesDesktop,
        perMove: this.perMoveDesktop,
        autoWidth: this.autoWidth,
        gap: this.gapDesktop,
        paddingCalc: this.paddingCalcDesktop,
        padding: {
          left: this.leftPaddingDesktop,
          right: this.rightPaddingDesktop,
        },
        destroy: this.destroyDesktop,
        classes: {
          arrow: `splide__arrow${this.arrowsColor}`,
          page: `splide__pagination__page${this.dotsColor}`,
        },
        easing: "cubic-bezier(0.25, 1, 0.5, 1)",
        breakpoints: {
          749: {
            omitEnd: this.omitEnd,
            type: this.typeMobile,
            perPage: this.slidesMobile,
            perMove: this.perMoveMobile,
            gap: this.gapMobile,
            paddingCalc: this.paddingCalcMobile,
            padding: {
              left: this.leftPaddingMobile,
              right: this.rightPaddingMobile,
            },
            destroy: this.destroyMobile,
          },
        },
      });
    let t = new Splide(this.sliderContainer, this.config);
    t.on("mounted", () => {
      let e = t.index,
        i = t.Components.Elements.slides[e];
      if (i) {
        let s = i.querySelector("img");
        s
          ? s.complete
            ? (i.classList.add("is-instant-active"),
              this.setActiveSlideHeight(i))
            : s.addEventListener("load", () => {
                i.classList.add("is-instant-active"),
                  this.setActiveSlideHeight(i);
              })
          : (i.classList.add("is-instant-active"),
            this.setActiveSlideHeight(i));
      }
      let n = debounce(() => {
        let e2 = t.Components.Elements.slides[t.index];
        this.setActiveSlideHeight(e2);
      }, 200);
      window.addEventListener("resize", n);
    }),
      t.on("move", (e) => {
        let i = t.index,
          s = t.Components.Elements.slides;
        if (s) {
          let n = s[i];
          n &&
            (s.forEach((t2) => t2.classList.remove("is-instant-active")),
            n.classList.add("is-instant-active"),
            this.setActiveSlideHeight(n));
        }
      }),
      this.dataset.pauseVideos === "true" &&
        t.on("hidden", (t2) => {
          let e = t2.slide.querySelector("internal-video");
          if (e) {
            let i = e.dataset.actionOnInactive;
            i === "pause"
              ? (e.video.pause(), e.classList.remove("internal-video--playing"))
              : i === "mute" &&
                ((e.video.muted = !0),
                e.classList.add("internal-video--muted"));
          }
        }),
      t.mount();
  }
  setActiveSlideHeight(t) {
    if (t) {
      let e = t.offsetHeight;
      this.style.setProperty("--active-slide-height", `${e}px`);
    }
  }
}
customElements.define("splide-component", SplideComponent);
class DetailsDisclosure extends HTMLElement {
  constructor() {
    super(),
      (this.mainDetailsToggle = this.querySelector("details")),
      (this.content =
        this.mainDetailsToggle.querySelector("summary").nextElementSibling),
      this.mainDetailsToggle.addEventListener(
        "focusout",
        this.onFocusOut.bind(this)
      ),
      this.mainDetailsToggle.addEventListener(
        "toggle",
        this.onToggle.bind(this)
      );
  }
  onFocusOut() {
    setTimeout(() => {
      this.contains(document.activeElement) || this.close();
    });
  }
  onToggle() {
    this.animations || (this.animations = this.content.getAnimations()),
      this.mainDetailsToggle.hasAttribute("open")
        ? this.animations.forEach((t) => t.play())
        : this.animations.forEach((t) => t.cancel());
  }
  close() {
    this.mainDetailsToggle.removeAttribute("open"),
      this.mainDetailsToggle
        .querySelector("summary")
        .setAttribute("aria-expanded", !1);
  }
}
customElements.define("details-disclosure", DetailsDisclosure);
class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super(), (this.header = document.querySelector(".header-wrapper"));
  }
  onToggle() {
    this.header &&
      ((this.header.preventHide = this.mainDetailsToggle.open),
      document.documentElement.style.getPropertyValue(
        "--header-bottom-position-desktop"
      ) === "" &&
        document.documentElement.style.setProperty(
          "--header-bottom-position-desktop",
          `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
        ));
  }
}
customElements.define("header-menu", HeaderMenu);
class DetailsModal extends HTMLElement {
  constructor() {
    super(),
      (this.detailsContainer = this.querySelector("details")),
      (this.summaryToggle = this.querySelector("summary")),
      this.detailsContainer.addEventListener(
        "keyup",
        (t) => t.code.toUpperCase() === "ESCAPE" && this.close()
      ),
      this.summaryToggle.addEventListener(
        "click",
        this.onSummaryClick.bind(this)
      ),
      this.querySelector('button[type="button"]').addEventListener(
        "click",
        this.close.bind(this)
      ),
      this.summaryToggle.setAttribute("role", "button");
  }
  isOpen() {
    return this.detailsContainer.hasAttribute("open");
  }
  onSummaryClick(t) {
    t.preventDefault(),
      t.target.closest("details").hasAttribute("open")
        ? this.close()
        : this.open(t);
  }
  onBodyClick(t) {
    (!this.contains(t.target) ||
      t.target.classList.contains("modal-overlay")) &&
      this.close(!1);
  }
  open(t) {
    (this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this)),
      t.target.closest("details").setAttribute("open", !0),
      document.body.addEventListener("click", this.onBodyClickEvent),
      document.body.classList.add("overflow-hidden"),
      typeof trapFocus == "function" &&
        trapFocus(
          this.detailsContainer.querySelector('[tabindex="-1"]'),
          this.detailsContainer.querySelector('input:not([type="hidden"])')
        );
  }
  close(t = !0) {
    typeof removeTrapFocus == "function" &&
      removeTrapFocus(t ? this.summaryToggle : null),
      this.detailsContainer.removeAttribute("open"),
      document.body.removeEventListener("click", this.onBodyClickEvent),
      document.body.classList.remove("overflow-hidden");
  }
}
customElements.define("details-modal", DetailsModal);
let hotspotButtons = [];
function registerHotspotButton(t) {
  hotspotButtons.push(t);
}
function unregisterHotspotButton(t) {
  let e = hotspotButtons.indexOf(t);
  e !== -1 && hotspotButtons.splice(e, 1);
}
document.addEventListener("mousedown", function (t) {
  for (let e of hotspotButtons)
    e.dataset.open !== "true" || e.contains(t.target) || e.closeModal();
});
class HotspotButton extends HTMLElement {
  constructor() {
    super(),
      (this.button = this.querySelector(".hotspot-btn")),
      (this.content = this.querySelector(".hotspot__content")),
      (this.type = this.dataset.type),
      (this.openEvent = this.dataset.openEvent),
      (this.header = document.querySelector(".section-header")),
      (this.stickyHeader = document.querySelector("sticky-header")),
      (this.mobileOverlay = this.querySelector(".hotspot-overlay")),
      this.button.addEventListener("click", this.toggleModal.bind(this)),
      this.openEvent === "hover" &&
        window.matchMedia("(hover: hover)").matches &&
        window.matchMedia("(pointer: fine)").matches &&
        (this.button.addEventListener("mouseover", this.openModal.bind(this)),
        this.button.addEventListener(
          "mouseout",
          this.startCheckingMouseLeave.bind(this)
        ),
        this.content.addEventListener(
          "mouseover",
          this.stopCheckingMouseLeave.bind(this)
        ),
        this.content.addEventListener(
          "mouseout",
          this.startCheckingMouseLeave.bind(this)
        )),
      this.mobileOverlay &&
        this.mobileOverlay.addEventListener(
          "click",
          this.closeModal.bind(this)
        );
  }
  startCheckingMouseLeave() {
    (this.checkingMouseLeave = !0),
      setTimeout(() => {
        this.checkingMouseLeave && this.closeModal();
      }, 200);
  }
  stopCheckingMouseLeave() {
    this.checkingMouseLeave = !1;
  }
  toggleModal() {
    this.dataset.open != "true" && this.openModal();
  }
  openModal() {
    let t = this.header.clientHeight;
    (this.header.classList.contains("shopify-section-header-hidden") ||
      !this.stickyHeader) &&
      (t = 0),
      this.content.getBoundingClientRect().top - t < 0 &&
        (this.dataset.direction = "bottom"),
      (this.dataset.open = "true");
  }
  closeModal() {
    (this.dataset.open = "false"),
      setTimeout(() => {
        this.dataset.direction = "";
      }, 100);
  }
  connectedCallback() {
    registerHotspotButton(this);
  }
  disconnectedCallback() {
    unregisterHotspotButton(this);
  }
}
customElements.define("hotspot-button", HotspotButton);
class ParallaxHero extends HTMLElement {
  constructor() {
    super(),
      (this.overlays = this.querySelectorAll(".parallax-hero__layer")),
      (this.animateOnEnter = this.dataset.animationStart === "bottom"),
      this.handleScroll(),
      window.addEventListener("scroll", () =>
        requestAnimationFrame(this.handleScroll.bind(this))
      );
  }
  handleScroll(t) {
    var { top: e, left: i, height: s } = this.getBoundingClientRect();
    let n = window.innerHeight,
      o;
    if (this.animateOnEnter) {
      if (e > n || e + s < 0) return;
      o = Math.min((n - e) / (n + s), 1);
    } else {
      if (e > n || e + s < 0) return;
      let r = e >= 0 ? 0 : -e;
      if (r > s) return;
      o = Math.min(r / s, 1);
    }
    this.overlays.forEach((t2) => {
      let i2 = e * (parseInt(t2.dataset.scrollY) / 100),
        s2 = parseInt(t2.dataset.scrollX) * o,
        n2 = 100 + (parseInt(t2.dataset.zoom) - 100) * o,
        r = 3.6 * parseInt(t2.dataset.rotation) * o;
      t2.style.transform = `translateY(${i2}px) translateX(${s2}%) scale(${
        n2 / 100
      }) rotate(${r}deg)`;
    });
  }
}
customElements.define("parallax-hero", ParallaxHero);
class ContentTabs extends HTMLElement {
  constructor() {
    super(),
      (this.buttons = this.querySelectorAll(".content-tab-button")),
      (this.tabs = this.querySelectorAll(".content-tab")),
      (this.tabsContainer = this.querySelector(".content-tabs__tabs")),
      (this.activeButton = this.querySelector(".content-tab-button--active")),
      (this.activeTab = this.querySelector(".content-tab--active")),
      (this.isMovingAnimation = this.dataset.animation === "moving"),
      this.isMovingAnimation &&
        ((this.activeBg = this.querySelector(".content-tab-buttom__active-bg")),
        this.handleActiveBg(),
        (this.activeBg.style.transitionDuration = "0.4s")),
      this.setHeight(),
      this.buttons.forEach((t) => {
        t.addEventListener("click", this.handleClick.bind(this));
      }),
      window.addEventListener("resize", () => {
        this.setHeight(), this.isMovingAnimation && this.handleActiveBg();
      });
  }
  handleClick(t) {
    (this.activeButton = t.currentTarget),
      this.buttons.forEach((t2) => {
        t2.classList.remove("content-tab-button--active");
      }),
      this.activeButton.classList.add("content-tab-button--active"),
      this.tabs.forEach((t2) => {
        t2.classList.remove("content-tab--active"),
          t2.dataset.index === this.activeButton.dataset.index &&
            (this.activeTab = t2);
      }),
      this.activeTab.classList.add("content-tab--active"),
      this.setHeight(),
      this.isMovingAnimation && this.handleActiveBg();
  }
  setHeight() {
    this.activeTab &&
      (this.tabsContainer.style.height = this.activeTab.clientHeight + "px");
  }
  handleActiveBg() {
    (this.activeBg.style.width =
      this.activeButton.getBoundingClientRect().width + "px"),
      (this.activeBg.style.height =
        this.activeButton.getBoundingClientRect().height + "px"),
      (this.activeBg.style.top = this.activeButton.offsetTop + "px"),
      (this.activeBg.style.left = this.activeButton.offsetLeft + "px");
  }
}
customElements.define("content-tabs", ContentTabs);
class InstaStories extends HTMLElement {
  constructor() {
    super(),
      (this.openButtons = this.querySelectorAll(".insta-story-open-btn")),
      (this.openButtonsOverflowContainer = this.querySelector(
        ".insta-stories__open-buttons-container"
      )),
      (this.openButtonsContainer = this.querySelector(
        ".insta-stories__open-buttons"
      )),
      (this.openBtnsPrev = this.querySelector(
        ".insta-stories__open-btns-prev"
      )),
      (this.openBtnsNext = this.querySelector(
        ".insta-stories__open-btns-next"
      )),
      (this.closeButtons = this.querySelectorAll(
        ".insta-stories__close-button"
      )),
      (this.modal = this.querySelector(".insta-stories__modal")),
      (this.modalOpen = !1),
      (this.slider = this.querySelector(".insta-stories__slider")),
      (this.stories = this.querySelectorAll(".insta-story")),
      (this.prevBtns = this.querySelectorAll(".insta-story__prev")),
      (this.nextBtns = this.querySelectorAll(".insta-story__next")),
      (this.slideBtns = this.querySelectorAll(".insta-story__slide-btn")),
      (this.activeIndex = 0),
      (this.activeStory = this.stories[this.activeIndex]),
      (this.lastIndex = parseInt(this.dataset.lastIndex)),
      (this.pauseResumeBtns = this.querySelectorAll(
        ".insta-story__pause-resume-btn"
      )),
      (this.isPaused = !1),
      (this.volumeBtns = this.querySelectorAll(".insta-story__volume-btn")),
      (this.isMuted = !0),
      this.initStories(),
      this.initButtonsSlider(),
      this.openButtons.forEach((t) => {
        t.addEventListener("click", this.openModal.bind(this));
      }),
      this.closeButtons.forEach((t) => {
        t.addEventListener("click", this.closeModal.bind(this));
      }),
      this.prevBtns.forEach((t) => {
        t.addEventListener("click", this.storyPrevBtnClick.bind(this));
      }),
      this.nextBtns.forEach((t) => {
        t.addEventListener("click", this.storyNextBtnClick.bind(this));
      }),
      this.slideBtns.forEach((t) => {
        t.addEventListener("click", this.slideBtnClick.bind(this));
      }),
      this.pauseResumeBtns.forEach((t) => {
        t.addEventListener("click", this.togglePauseResume.bind(this));
      }),
      this.volumeBtns.forEach((t) => {
        t.addEventListener("click", this.toggleIsMuted.bind(this));
      }),
      this.slider.addEventListener(
        "touchstart",
        this.touchStartHandler.bind(this)
      ),
      this.slider.addEventListener("touchend", this.touchEndHandler.bind(this)),
      document.addEventListener("keydown", (t) => {
        if (this.modalOpen)
          switch (t.key) {
            case "Escape":
              this.closeModal();
              break;
            case "ArrowLeft":
              this.storyPrevBtnClick();
              break;
            case "ArrowRight":
              this.storyNextBtnClick();
          }
      }),
      Shopify.designMode &&
        (document.addEventListener("shopify:section:load", () => {
          this.initStories(), this.initButtonsSlider();
        }),
        document.addEventListener("shopify:section:reorder", () => {
          this.initStories(), this.initButtonsSlider();
        }));
  }
  autoplay() {
    let t = this.activeStory,
      e = parseInt(t.dataset.activeMediaIndex),
      i = t.querySelectorAll(".insta-story__media")[e],
      s = 1e3 * parseInt(i.getAttribute("data-duration"));
    this.updateProgressBars(e),
      (this.autoplayStartTime = Date.now()),
      (this.autoplayTimeout = setTimeout(() => {
        this.storyNextBtnClick();
      }, s));
  }
  storyPrevBtnClick() {
    let t = this.activeStory;
    t.dataset.activeMediaIndex === "0"
      ? this.changeActiveStory(this.activeIndex - 1)
      : this.changeActiveMedia(parseInt(t.dataset.activeMediaIndex) - 1);
  }
  storyNextBtnClick() {
    let t = this.activeStory;
    t.dataset.activeMediaIndex === t.dataset.lastMediaIndex
      ? this.changeActiveStory(this.activeIndex + 1)
      : this.changeActiveMedia(parseInt(t.dataset.activeMediaIndex) + 1);
  }
  slideBtnClick(t) {
    let e = parseInt(t.currentTarget.dataset.index);
    this.changeActiveStory(e);
  }
  changeActiveStory(t) {
    if ((clearTimeout(this.autoplayTimeout), t > this.lastIndex || t < 0))
      return;
    let e = this.stories[this.activeIndex],
      i = parseInt(e.dataset.activeMediaIndex);
    if (e.dataset.played === "true" || i > 0) {
      let s = e.querySelectorAll(".insta-story__progress-item")[i];
      s &&
        (s.classList.remove("insta-story__progress-item--active"),
        t > this.activeIndex &&
          s.classList.add("insta-story__progress-item--completed"));
    }
    let n = e.querySelectorAll(".insta-story__media")[i];
    if (n && n.getAttribute("data-type") === "video") {
      let o = n.querySelector("video");
      o && (o.pause(), this.isPaused || (o.currentTime = 0));
    }
    (this.activeIndex = t),
      (this.activeStory = this.stories[this.activeIndex]),
      this.stories.forEach((t2) => {
        t2.classList.remove("insta-story--active");
      }),
      this.activeStory.classList.add("insta-story--active"),
      (this.activeStory.dataset.played = "true"),
      (this.slider.style.transform = `translateX(calc(var(--story-width) * ${
        this.activeIndex * (isRtl ? 1 : -1)
      }))`);
    let r = parseInt(this.activeStory.dataset.activeMediaIndex, 10);
    this.changeActiveMedia(r), this.updateProgressBars(r);
  }
  changeActiveMedia(t) {
    if ((clearTimeout(this.autoplayTimeout), t < 0)) return;
    let e = this.activeStory,
      i = parseInt(e.dataset.lastMediaIndex);
    if (t > i) return;
    e.dataset.activeMediaIndex = t;
    let s = e.querySelectorAll(".insta-story__media");
    for (let n = 0; n < s.length; n++)
      if (n === t) {
        if (
          ((s[n].style.display = "block"),
          s[n].getAttribute("data-type") === "video")
        ) {
          let o = s[n].querySelector("video");
          o && !this.isPaused && o.play();
        }
        e.querySelector(".insta-story__time-posted").innerHTML =
          s[n].dataset.timePosted;
      } else if (
        ((s[n].style.display = ""), s[n].getAttribute("data-type") === "video")
      ) {
        let r = s[n].querySelector("video");
        r && (r.pause(), this.isPaused || (r.currentTime = 0));
      }
    this.updateProgressBars(t), this.isPaused || this.autoplay();
    let a = e.querySelectorAll(".insta-story__prev"),
      l = e.querySelectorAll(".insta-story__next");
    a.forEach((e2) => {
      this.activeIndex === 0 && t === 0
        ? e2.setAttribute("disabled", "")
        : e2.removeAttribute("disabled");
    }),
      l.forEach((e2) => {
        this.activeIndex === this.lastIndex && t === i
          ? e2.setAttribute("disabled", "")
          : e2.removeAttribute("disabled");
      });
  }
  updateProgressBars(t) {
    this.activeStory
      .querySelectorAll(".insta-story__progress-item")
      .forEach((e2, i2) => {
        e2.classList.remove(
          "insta-story__progress-item--completed",
          "insta-story__progress-item--active"
        ),
          i2 < t
            ? e2.classList.add("insta-story__progress-item--completed")
            : i2 === t &&
              e2.classList.add("insta-story__progress-item--active");
      });
  }
  openModal(t) {
    window.scrollBy(0, -1),
      (this.modal.dataset.open = "true"),
      (this.modalOpen = !0),
      document.body.classList.add("overflow-hidden"),
      this.changeActiveStory(parseInt(t.currentTarget.dataset.index));
  }
  closeModal(t) {
    this.querySelectorAll("video").forEach((t2) => {
      t2.pause();
    }),
      (this.modal.dataset.open = "false"),
      (this.modalOpen = !1),
      document.body.classList.remove("overflow-hidden"),
      clearTimeout(this.autoplayTimeout);
  }
  initButtonsSlider() {
    if (
      this.openButtonsOverflowContainer.clientWidth >
      this.openButtonsContainer.clientWidth
    )
      return;
    let t = () => "ontouchstart" in window || navigator.maxTouchPoints,
      e,
      i = 0,
      s = 0,
      n = (t2) => {
        (this.openButtonsContainer.style.transform = `translateX(${t2}px)`),
          (i = t2);
      };
    this.openButtonsOverflowContainer.addEventListener("touchstart", (t2) => {
      (this.isDragging = !0), (e = t2.touches[0].clientX - s);
    }),
      this.openButtonsOverflowContainer.addEventListener("touchmove", (t2) => {
        if (!this.isDragging) return;
        let i2 = t2.touches[0].clientX,
          s2 = i2 - e;
        s2 < 0 &&
          Math.abs(s2) <=
            this.openButtonsContainer.offsetWidth -
              this.openButtonsOverflowContainer.offsetWidth &&
          n(s2);
      }),
      this.openButtonsOverflowContainer.addEventListener("touchend", () => {
        (this.isDragging = !1), (s = i);
      });
    let o = parseFloat(getComputedStyle(this.openButtons[0]).width),
      r = parseFloat(getComputedStyle(this.openButtonsContainer).columnGap),
      a = () =>
        (Math.floor(this.openButtonsOverflowContainer.clientWidth / (o + r)) -
          1) *
        (o + r),
      l = isRtl ? -1 : 1,
      d = () => {
        let t2 = this.openButtonsOverflowContainer.scrollLeft * l;
        (this.openBtnsPrev.style.display = t2 <= 0 ? "none" : "grid"),
          (this.openBtnsNext.style.display =
            t2 >
            this.openButtonsOverflowContainer.scrollWidth -
              this.openButtonsContainer.clientWidth
              ? "none"
              : "grid");
      };
    this.openBtnsPrev.addEventListener("click", () => {
      this.openButtonsOverflowContainer.scrollBy({
        left: -a() * l,
        behavior: "smooth",
      }),
        setTimeout(d, 300);
    }),
      this.openBtnsNext.addEventListener("click", () => {
        this.openButtonsOverflowContainer.scrollBy({
          left: a() * l,
          behavior: "smooth",
        }),
          setTimeout(d, 300);
      }),
      d(),
      t() &&
        ((this.openBtnsPrev.style.display = "none"),
        (this.openBtnsNext.style.display = "none")),
      window.addEventListener(
        "resize",
        debounce(() => {
          this.openButtonsOverflowContainer.clientWidth <=
          this.openButtonsContainer.clientWidth
            ? t()
              ? ((this.openBtnsPrev.style.display = "none"),
                (this.openBtnsNext.style.display = "none"))
              : d()
            : ((this.openBtnsPrev.style.display = "none"),
              (this.openBtnsNext.style.display = "none"));
        }, 250)
      );
  }
  initStories() {
    this.stories.forEach((t) => {
      let e = t.querySelectorAll(".insta-story__media");
      (t.dataset.lastMediaIndex = e.length - 1), (t.dataset.played = "false");
      let i = t.querySelector(".insta-story__progress");
      for (let s = 0; s < e.length; s++) {
        let n = e[s].getAttribute("data-duration"),
          o = document.createElement("span");
        (o.className = "insta-story__progress-item"),
          o.style.setProperty("--duration", `${n}s`);
        let r = document.createElement("span");
        (r.className = "insta-story__progress-bar"),
          o.appendChild(r),
          i.appendChild(o);
      }
      let a = parseInt(t.dataset.activeMediaIndex);
      e[a] && (e[a].style.display = "block");
    });
  }
  togglePauseResume(t) {
    let e = t.currentTarget.getAttribute("data-paused") === "true";
    e ? this.resumeStory() : this.pauseStory(),
      this.pauseResumeBtns.forEach((t2) => {
        t2.setAttribute("data-paused", e ? "false" : "true");
      });
  }
  pauseStory() {
    this.isPaused = !0;
    let t = this.activeStory.querySelectorAll(".insta-story__media")[
        parseInt(this.activeStory.dataset.activeMediaIndex)
      ],
      e = 1e3 * parseInt(t.getAttribute("data-duration"));
    if (
      ((this.remainingTime = e - (Date.now() - this.autoplayStartTime)),
      clearTimeout(this.autoplayTimeout),
      t.getAttribute("data-type") === "video")
    ) {
      let i = t.querySelector("video");
      i && i.pause();
    }
    this.querySelectorAll(".insta-story__progress-bar").forEach((t2) => {
      t2.style.animationPlayState = "paused";
    });
  }
  resumeStory() {
    (this.isPaused = !1),
      this.querySelectorAll(".insta-story__progress-bar").forEach((t2) => {
        t2.style.animationPlayState = "running";
      });
    let e = this.activeStory.querySelectorAll(".insta-story__media")[
      parseInt(this.activeStory.dataset.activeMediaIndex)
    ];
    if (e.getAttribute("data-type") === "video") {
      let i = e.querySelector("video");
      i && i.play();
    }
    (this.autoplayStartTime = Date.now()),
      (this.autoplayTimeout = setTimeout(() => {
        this.storyNextBtnClick();
      }, this.remainingTime));
  }
  toggleIsMuted(t) {
    t.currentTarget,
      (this.isMuted = !this.isMuted),
      this.querySelectorAll("video").forEach((t2) => {
        t2.muted = this.isMuted;
      }),
      this.volumeBtns.forEach((t2) => {
        this.isMuted
          ? t2.setAttribute("data-muted", "true")
          : t2.setAttribute("data-muted", "false");
      });
  }
  touchStartHandler(t) {
    this.touchStartX = t.touches[0].clientX;
  }
  touchEndHandler(t) {
    let e = t.changedTouches[0].clientX,
      i = e - this.touchStartX;
    if (50 > Math.abs(i)) return;
    let s = isRtl ? -1 : 1;
    i < 0
      ? this.activeIndex < this.lastIndex &&
        this.changeActiveStory(this.activeIndex + s)
      : this.activeIndex > 0 && this.changeActiveStory(this.activeIndex - s);
  }
}
customElements.define("insta-stories", InstaStories);
class TncCheckbox extends HTMLElement {
  constructor() {
    super(),
      (this.checked = !1),
      (this.checkoutButton = document.querySelector("#CartDrawer-Checkout")),
      (this.disableButton = this.dataset.disableButton === "true"),
      (this.warningText = this.dataset.warningText),
      (this.warningTextElement = document.querySelector(
        `.tnc-checkbox-warning--${this.dataset.warningPosition}`
      )),
      !(!this.checkoutButton || !this.warningTextElement) &&
        (this.warningTextElement &&
          (this.warningTextElement.innerHTML = this.warningText),
        this.disableButton && this.checkoutButton.classList.add("disabled"),
        this.addEventListener("click", this.handleCheckboxClick.bind(this)),
        this.checkoutButton.addEventListener(
          "click",
          this.handleButtonClick.bind(this)
        ));
  }
  handleCheckboxClick(t) {
    (this.checked = !this.checked),
      (this.dataset.checked = this.checked),
      this.checked
        ? (this.warningTextElement.classList.add("hidden"),
          this.disableButton &&
            this.checkoutButton.classList.remove("disabled"))
        : this.disableButton && this.checkoutButton.classList.add("disabled");
  }
  handleButtonClick(t) {
    this.checked !== !0 &&
      (t.preventDefault(), this.warningTextElement.classList.remove("hidden"));
  }
}
customElements.define("tnc-chekcbox", TncCheckbox);
class ContactForm extends HTMLElement {
  constructor() {
    super(),
      (this.handleFormSubmit = this.handleFormSubmit.bind(this)),
      (this.handleFieldInput = this.handleFieldInput.bind(this));
  }
  connectedCallback() {
    (this.form = this.querySelector("form")),
      this.form &&
        ((this.requiredFields = Array.from(
          this.querySelectorAll('.field-wrapper[data-required="true"]')
        )),
        this.requiredFields.length > 0 &&
          (this.form.addEventListener("submit", this.handleFormSubmit),
          this.requiredFields.forEach((t) => {
            let e = t.querySelector(".field__input, .text-area");
            e && e.addEventListener("input", this.handleFieldInput);
          })));
  }
  disconnectedCallback() {
    this.form && this.form.removeEventListener("submit", this.handleFormSubmit),
      this.requiredFields.forEach((t) => {
        let e = t.querySelector(".field__input, .text-area");
        e && e.removeEventListener("input", this.handleFieldInput);
      });
  }
  handleFormSubmit(t) {
    let e = !0;
    this.requiredFields.forEach((t2) => {
      let i = t2.querySelector(".field__input, .text-area"),
        s = t2.querySelector(".field-wrapper__error-msg");
      i &&
        !i.value.trim() &&
        ((e = !1),
        t2.classList.add("field-wrapper--error"),
        s && s.classList.remove("hidden"));
    }),
      e || t.preventDefault();
  }
  handleFieldInput(t) {
    let e = t.target,
      i = e.closest(".field-wrapper"),
      s = i.querySelector(".field-wrapper__error-msg");
    i.classList.remove("field-wrapper--error"), s && s.classList.add("hidden");
  }
}
customElements.define("contact-form", ContactForm);
